import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.villages');
import { ChangeDetectorRef, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { workflowStatusClass, workflowStatusLabel } from '../shared/workflow-status';

@Component({
    selector: 'wiz-page-villages',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.villages/view.scss */
:host {
  display: block;
  height: 100%;
}

.field-missing {
  border-color: var(--ops-warning-border) !important;
  background: var(--ops-warning-soft) !important;
}

.field-missing:focus {
  border-color: var(--ops-warning) !important;
  box-shadow: 0 0 0 2px rgba(154, 106, 18, 0.16) !important;
}

.ops-registry-inner {
  height: 100%;
  max-width: var(--ops-content-max);
}

.ops-console-toolbar {
  flex: 0 0 auto;
  min-height: var(--ops-page-header-height);
}

.ops-console-message-row {
  display: grid;
  flex: 0 0 auto;
  gap: 8px;
}

.ops-console-layout {
  grid-template-columns: 288px minmax(560px, 1fr) 304px;
  align-items: stretch;
  min-height: 620px;
  height: calc(100vh - 176px);
}

.ops-console-list-panel,
.ops-console-detail-panel,
.ops-deploy-panel {
  min-height: 0;
  overflow: hidden;
  border: 1px solid var(--ops-panel-border);
  border-radius: var(--ops-radius);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: var(--ops-shadow);
}

.ops-console-list-panel,
.ops-deploy-panel {
  display: flex;
  flex-direction: column;
}

.ops-console-detail-panel {
  overflow: auto;
}

.ops-console-panel-head {
  padding: 12px;
  border-bottom: 1px solid var(--ops-border-subtle);
}

.ops-console-panel-head h2,
.ops-action-stack h2 {
  margin-top: 4px;
  color: var(--ops-heading);
  font-size: 14px !important;
  font-weight: 900;
}

.ops-console-filter-stack {
  display: grid;
  gap: 8px;
  border-bottom: 1px solid var(--ops-border-subtle);
  padding: 10px 12px;
}

.ops-console-filter-stack .ops-search-field,
.ops-console-filter-stack label {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.ops-console-filter-stack span {
  color: var(--ops-muted);
  font-size: 10px;
  font-weight: 900;
}

.ops-console-filter-stack input,
.ops-console-filter-stack select {
  width: 100%;
  min-height: 34px;
  border: 1px solid var(--ops-border-strong);
  border-radius: var(--ops-radius-sm);
  background: #ffffff;
  color: var(--ops-text);
  font-size: 12px;
  font-weight: 800;
  padding: 0 9px;
}

.ops-filter-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.ops-template-list {
  display: flex;
  min-height: 0;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 6px;
  overflow: auto;
  padding: 10px;
}

.ops-template-row {
  display: grid;
  width: 100%;
  min-width: 0;
  gap: 7px;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: #ffffff;
  padding: 10px;
  text-align: left;
  transition: border-color 140ms ease, background-color 140ms ease, box-shadow 140ms ease;
}

.ops-template-row:hover,
.ops-template-row.is-selected {
  border-color: var(--ops-primary-dark);
  background: #f7faf8;
  box-shadow: inset 3px 0 0 var(--ops-primary-dark);
}

.ops-template-row-topline,
.ops-template-row-main,
.ops-template-row-meta,
.ops-template-row-foot {
  display: flex;
  min-width: 0;
  gap: 6px;
}

.ops-template-row-topline {
  align-items: center;
  justify-content: space-between;
}

.ops-template-row-main {
  flex-direction: column;
}

.ops-template-row-main strong,
.ops-template-row-main em,
.ops-template-row-topline small,
.ops-template-row-foot small,
.ops-rule-row strong,
.ops-rule-row span,
.ops-rule-row em {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-template-row-main strong {
  color: var(--ops-heading);
  font-size: 12px;
  font-weight: 900;
}

.ops-template-row-main em,
.ops-template-row-topline small,
.ops-template-row-foot small {
  color: var(--ops-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.ops-template-progress {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 8px;
  align-items: center;
}

.ops-template-progress i {
  display: block;
  height: 6px;
  overflow: hidden;
  border: 1px solid var(--ops-border);
  background: #eef2f1;
}

.ops-template-progress b {
  display: block;
  height: 100%;
  background: #2f7f62;
}

.ops-template-progress small {
  color: var(--ops-muted-strong);
  font-size: 10px;
  font-weight: 900;
  white-space: nowrap;
}

.ops-template-row-meta,
.ops-template-row-foot {
  flex-wrap: wrap;
}

.ops-console-pagination {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  gap: 5px;
  border-top: 1px solid var(--ops-border);
  padding: 8px 10px;
}

.ops-console-pagination button {
  min-height: 30px;
  min-width: 30px;
  border: 1px solid var(--ops-border-strong);
  border-radius: var(--ops-radius-sm);
  background: #ffffff;
  color: var(--ops-text);
  font-size: 11px;
  font-weight: 900;
  padding: 0 9px;
}

.ops-console-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.ops-detail-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid var(--ops-border);
  padding: 15px 16px;
}

.ops-detail-header h2 {
  margin-top: 5px;
  color: var(--ops-heading);
  font-size: 24px !important;
  font-weight: 900;
  line-height: 1.25;
}

.ops-detail-actions {
  display: flex;
  flex: 0 0 auto;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.ops-config-board {
  display: flex;
  flex-direction: column;
}

.ops-config-row {
  display: grid;
  grid-template-columns: 132px minmax(0, 1fr);
  gap: 12px;
  border-bottom: 1px solid var(--ops-border);
  padding: 12px 16px;
}

.ops-config-row:last-child {
  border-bottom: 0;
}

.ops-config-label {
  display: grid;
  align-content: start;
  gap: 6px;
}

.ops-config-label span {
  display: inline-flex;
  width: fit-content;
  min-height: 22px;
  align-items: center;
  border-radius: 999px;
  background: var(--ops-primary-dark);
  color: #ffffff;
  font-size: 10px;
  font-weight: 900;
  padding: 0 8px;
}

.ops-config-label strong {
  color: var(--ops-heading);
  font-size: 13px;
  font-weight: 900;
}

.ops-config-label em {
  color: var(--ops-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  line-height: 1.35;
}

.ops-config-dl {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 7px;
  margin: 0;
}

.ops-config-dl.is-compact {
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.ops-config-dl > div {
  min-width: 0;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-surface-muted);
  padding: 8px 9px;
}

.ops-config-dl dt {
  color: var(--ops-muted);
  font-size: 10px;
  font-weight: 900;
}

.ops-config-dl dd {
  margin: 5px 0 0;
  overflow: hidden;
  color: var(--ops-heading);
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-structure-table {
  min-width: 0;
  overflow: auto;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
}

.ops-structure-table.is-scrollable {
  max-height: 238px;
}

.ops-structure-table .ops-data-table {
  width: 100%;
  min-width: 620px;
}

.ops-settings-page table {
  min-width: 620px;
}

.ops-capture-matrix {
  display: grid;
  gap: 8px;
}

.ops-rule-list {
  display: grid;
  gap: 6px;
}

.ops-rule-row {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr) minmax(104px, 0.72fr);
  gap: 8px;
  align-items: center;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: #ffffff;
  padding: 8px 9px;
}

.ops-rule-row strong {
  color: var(--ops-muted-strong);
  font-size: 11px;
  font-weight: 900;
}

.ops-rule-row span {
  color: var(--ops-heading);
  font-size: 12px;
  font-weight: 900;
}

.ops-rule-row em {
  color: var(--ops-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.ops-deploy-panel {
  gap: 0;
  overflow: auto;
}

.ops-deploy-status-block,
.ops-action-stack {
  display: flex;
  flex-direction: column;
  gap: 8px;
  border-bottom: 1px solid var(--ops-border);
  padding: 13px;
}

.ops-deploy-status-block h2 {
  color: var(--ops-heading);
  font-size: 25px !important;
  font-weight: 900;
}

.ops-deploy-status-block p {
  color: var(--ops-muted-strong);
  font-size: 12px;
  font-weight: 800;
  line-height: 1.42;
}

.ops-action-row {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: #ffffff;
  padding: 8px 9px;
  text-align: left;
}

.ops-action-row span {
  display: grid;
  min-width: 0;
  gap: 3px;
}

.ops-action-row strong,
.ops-action-row em {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-action-row strong {
  color: var(--ops-heading);
  font-size: 12px;
  font-weight: 900;
}

.ops-action-row em {
  color: var(--ops-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.ops-action-row small {
  flex: 0 0 auto;
  border: 1px solid var(--ops-border);
  border-radius: 999px;
  background: #ffffff;
  color: var(--ops-muted-strong);
  font-size: 11px;
  font-weight: 900;
  padding: 4px 8px;
}

.ops-action-stack.is-compact-actions {
  border-bottom: 0;
}

.ops-console-empty-note {
  border: 1px dashed var(--ops-border-strong);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-surface-muted);
  color: var(--ops-muted-strong);
  font-size: 12px;
  font-weight: 800;
  line-height: 1.5;
  padding: 11px;
  text-align: center;
}

.ops-console-empty-state {
  margin: 16px;
}

.ops-wizard-shell {
  display: flex;
  min-height: 0;
  flex-direction: column;
  gap: 12px;
}

.ops-wizard-strip {
  display: grid;
  grid-template-columns: repeat(6, minmax(0, 1fr));
  gap: 8px;
}

.ops-wizard-step {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  gap: 3px 8px;
  min-height: 54px;
  align-items: center;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: #ffffff;
  padding: 8px;
  text-align: left;
}

.ops-wizard-step > span {
  grid-row: span 2;
  display: inline-flex;
  width: 26px;
  height: 26px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  font-size: 11px;
  font-weight: 900;
}

.ops-wizard-step strong,
.ops-wizard-step em {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-wizard-step strong {
  color: var(--ops-heading);
  font-size: 12px;
  font-weight: 900;
}

.ops-wizard-step em {
  color: var(--ops-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
}

.ops-wizard-workbench {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 12px;
  align-items: start;
}

.ops-wizard-canvas,
.ops-wizard-review {
  min-width: 0;
}

.ops-wizard-review {
  position: sticky;
  top: 14px;
}

.ops-deploy-step {
  display: grid;
  gap: 14px;
}

.ops-deploy-step-summary {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 7px;
}

.ops-deploy-step-summary div {
  min-width: 0;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: var(--ops-surface-muted);
  padding: 9px;
}

.ops-deploy-step-summary span {
  display: block;
  color: var(--ops-muted);
  font-size: 11px;
  font-weight: 900;
}

.ops-deploy-step-summary strong {
  display: block;
  margin-top: 5px;
  overflow: hidden;
  color: var(--ops-heading);
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ops-deploy-confirm {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border: 1px solid var(--ops-border);
  border-radius: var(--ops-radius-sm);
  background: #ffffff;
  padding: 11px;
}

.ops-deploy-confirm p {
  color: var(--ops-muted-strong);
  font-size: 12px;
  font-weight: 800;
  line-height: 1.5;
}

@media (max-width: 1399px) {
  .ops-console-layout,
  .ops-wizard-workbench {
    height: auto;
    grid-template-columns: 1fr;
  }
  .ops-console-layout {
    min-height: 0;
  }
  .ops-console-list-panel,
  .ops-deploy-panel,
  .ops-wizard-review {
    position: static;
  }
  .ops-template-list {
    max-height: 420px;
  }
  .ops-wizard-strip {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@media (max-width: 900px) {
  .ops-console-toolbar,
  .ops-detail-header,
  .ops-deploy-confirm {
    flex-direction: column;
    align-items: stretch;
  }
  .ops-config-row {
    grid-template-columns: 1fr;
  }
  .ops-config-dl,
  .ops-config-dl.is-compact,
  .ops-deploy-step-summary {
    grid-template-columns: 1fr;
  }
  .ops-rule-row {
    grid-template-columns: 1fr;
  }
  .ops-wizard-strip {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 639px) {
  .ops-filter-grid {
    grid-template-columns: 1fr;
  }
  .ops-settings-page footer > div,
  .ops-settings-page footer button {
    width: 100%;
  }
}
.criteria-studio-shell {
  --criteria-surface: #ffffff;
  --criteria-soft: #f7faf8;
  --criteria-soft-strong: #eef5f1;
  --criteria-line: #d9e3dd;
  --criteria-line-strong: #c3d0c8;
  --criteria-ink: #14201a;
  --criteria-muted: #64736b;
  --criteria-green: #2f7f62;
  --criteria-blue: #2872a5;
  --criteria-amber: #b66a00;
  --criteria-shadow: 0 10px 24px rgba(20, 32, 26, 0.07);
  min-height: 100%;
  padding: 18px 18px 30px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.86), rgba(255, 255, 255, 0) 240px), linear-gradient(135deg, rgba(47, 127, 98, 0.08), rgba(40, 114, 165, 0.05) 42%, rgba(182, 106, 0, 0.05)), #eef4f1;
  color: var(--ops-text);
  word-break: keep-all;
}

.criteria-studio-inner {
  max-width: none;
  gap: 14px;
}

.criteria-command-line,
.criteria-writer-command {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 16px;
  min-height: 76px;
  border-bottom: 2px solid #111714;
  padding: 0 2px 14px;
}

.criteria-command-line .ops-desk-title h1,
.criteria-writer-command .ops-desk-title h1 {
  font-size: 28px !important;
}

.criteria-kpi-strip {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
}

.criteria-kpi-card {
  display: grid;
  min-width: 0;
  min-height: 78px;
  align-content: center;
  gap: 5px;
  border: 0;
  border-right: 1px solid var(--ops-border);
  background: #ffffff;
  padding: 12px 16px;
  text-align: left;
  transition: background-color 140ms ease, box-shadow 140ms ease;
}

.criteria-kpi-card:last-child {
  border-right: 0;
}

.criteria-kpi-card:hover,
.criteria-kpi-card.is-active {
  background: #f8faf9;
  box-shadow: inset 0 -3px 0 #111714;
}

.criteria-kpi-card span,
.criteria-kpi-card em {
  overflow: hidden;
  color: var(--ops-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-kpi-card strong {
  overflow: hidden;
  color: var(--ops-heading);
  font-size: 24px;
  font-weight: 900;
  line-height: 1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-kpi-card small {
  margin-left: 2px;
  color: var(--ops-muted-strong);
  font-size: 12px;
  font-weight: 900;
}

.criteria-kpi-card.is-ready {
  box-shadow: inset 4px 0 0 #2f7f62;
}

.criteria-kpi-card.is-warning {
  box-shadow: inset 4px 0 0 #c47a00;
}

.criteria-kpi-card.is-deployed {
  box-shadow: inset 4px 0 0 #2770a8;
}

.criteria-kpi-card.is-active {
  box-shadow: inset 0 -3px 0 #111714, inset 4px 0 0 currentColor;
}

.criteria-home-screen,
.criteria-detail-screen {
  display: grid;
  gap: 12px;
}

.criteria-home-grid {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 12px;
  align-items: start;
}

.criteria-list-workbench,
.criteria-priority-section,
.criteria-detail-screen {
  min-width: 0;
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
}

.criteria-priority-panel {
  display: grid;
  gap: 12px;
  min-width: 0;
}

.criteria-panel-title {
  display: flex;
  min-height: 56px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid var(--ops-border-strong);
  padding: 0 16px;
}

.criteria-panel-title h2 {
  margin-top: 4px;
  color: var(--ops-heading);
  font-size: 15px !important;
  font-weight: 900;
}

.criteria-list-toolbar {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) 150px 150px 150px;
  gap: 8px;
  border-bottom: 1px solid var(--ops-border);
  background: #f8faf9;
  padding: 12px;
}

.criteria-list-toolbar label,
.criteria-search-field {
  display: grid;
  min-width: 0;
  gap: 5px;
}

.criteria-list-toolbar span,
.criteria-search-field span {
  color: var(--ops-muted);
  font-size: 10px;
  font-weight: 900;
}

.criteria-list-toolbar input,
.criteria-list-toolbar select {
  width: 100%;
  min-height: 36px;
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
  color: var(--ops-text);
  font-size: 12px;
  font-weight: 800;
  padding: 0 10px;
}

.criteria-list-workbench > .criteria-filter-summary {
  border-bottom: 1px solid var(--ops-border);
  background: #ffffff;
  padding: 9px 12px;
}

.criteria-table {
  display: grid;
}

.criteria-table-head,
.criteria-table-row {
  display: grid;
  grid-template-columns: minmax(250px, 1.22fr) 132px minmax(210px, 0.9fr) 150px 64px;
  gap: 12px;
  align-items: center;
}

.criteria-table-head {
  min-height: 38px;
  border-bottom: 1px solid var(--ops-border);
  background: #f5f7f6;
  padding: 0 14px;
}

.criteria-table-head span {
  color: var(--ops-muted);
  font-size: 11px;
  font-weight: 900;
}

.criteria-table-head span:not(:first-child) {
  text-align: center;
}

.criteria-table-row {
  width: 100%;
  min-height: 76px;
  border: 0;
  border-bottom: 1px solid var(--ops-border);
  background: #ffffff;
  padding: 12px 14px;
  text-align: left;
}

.criteria-table-row:hover {
  background: #f8faf9;
}

.criteria-table-main,
.criteria-table-date,
.criteria-table-status {
  display: grid;
  min-width: 0;
  gap: 6px;
}

.criteria-table-main strong,
.criteria-priority-row strong {
  overflow: hidden;
  color: var(--ops-heading);
  font-size: 14px;
  font-weight: 900;
  line-height: 1.25;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-table-main em,
.criteria-table-date small,
.criteria-table-status small,
.criteria-priority-row span,
.criteria-priority-row em {
  overflow: hidden;
  color: var(--ops-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-table-date {
  justify-items: center;
  text-align: center;
}

.criteria-table-status {
  grid-template-columns: repeat(2, max-content);
  align-items: center;
  justify-content: center;
  justify-items: center;
  text-align: center;
}

.criteria-table-status small {
  grid-column: 1/-1;
}

.criteria-table-progress {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 38px;
  gap: 8px;
  align-items: center;
  justify-self: center;
  width: 142px;
}

.criteria-table-progress i {
  display: block;
  height: 8px;
  overflow: hidden;
  border: 1px solid var(--ops-border);
  background: #eef2f1;
}

.criteria-table-progress b {
  display: block;
  height: 100%;
  background: #2f7f62;
}

.criteria-table-progress small,
.criteria-table-action {
  color: var(--ops-muted-strong);
  font-size: 11px;
  font-weight: 900;
  white-space: nowrap;
}

.criteria-table-action {
  justify-self: center;
  text-align: center;
}

.criteria-priority-section {
  display: grid;
  gap: 10px;
  padding-bottom: 12px;
}

.criteria-priority-section .ops-command-button {
  width: calc(100% - 24px);
  margin: 0 12px;
}

.criteria-priority-row {
  display: grid;
  width: calc(100% - 24px);
  min-width: 0;
  gap: 5px;
  border: 1px solid var(--ops-border);
  background: #ffffff;
  margin: 0 12px;
  padding: 10px;
  text-align: left;
}

.criteria-priority-row:hover {
  border-color: #111714;
  background: #f8faf9;
}

.criteria-detail-hero {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  gap: 14px;
  align-items: center;
  border-bottom: 1px solid var(--ops-border-strong);
  padding: 14px 16px;
}

.criteria-detail-title {
  min-width: 0;
}

.criteria-detail-title h2 {
  margin-top: 5px;
  overflow: hidden;
  color: var(--ops-heading);
  font-size: 24px !important;
  font-weight: 900;
  line-height: 1.2;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-detail-buttons {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}

.criteria-detail-tabs {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-bottom: 1px solid var(--ops-border-strong);
  background: #f8faf9;
}

.criteria-detail-tabs button {
  display: flex;
  min-height: 46px;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  border: 0;
  border-right: 1px solid var(--ops-border);
  background: transparent;
  padding: 0 14px;
  text-align: left;
}

.criteria-detail-tabs button:last-child {
  border-right: 0;
}

.criteria-detail-tabs button.is-active {
  background: #ffffff;
  box-shadow: inset 0 -3px 0 #111714;
}

.criteria-detail-tabs strong,
.criteria-detail-tabs span {
  overflow: hidden;
  color: var(--ops-heading);
  font-size: 12px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-detail-tabs span {
  color: var(--ops-muted);
}

.criteria-detail-body,
.criteria-tab-panel {
  min-width: 0;
}

.criteria-tab-panel {
  display: grid;
  gap: 12px;
  padding: 16px;
}

.criteria-check-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
}

.criteria-section-head {
  display: flex;
  min-height: 34px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.criteria-section-head strong {
  color: var(--ops-heading);
  font-size: 14px;
  font-weight: 900;
}

.criteria-section-head span {
  color: var(--ops-muted);
  font-size: 12px;
  font-weight: 900;
}

.criteria-release-runway {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) minmax(220px, 0.7fr) auto;
  align-items: stretch;
  min-height: 86px;
  border: 1px solid #111714;
  background: #101915;
  color: #ffffff;
}

.criteria-release-main,
.criteria-release-meter,
.criteria-release-actions {
  min-width: 0;
  border-right: 1px solid rgba(255, 255, 255, 0.12);
  padding: 14px 16px;
}

.criteria-release-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  border-right: 0;
}

.criteria-release-main {
  display: grid;
  align-content: center;
  gap: 5px;
}

.criteria-release-main span,
.criteria-release-main em {
  overflow: hidden;
  color: rgba(240, 248, 244, 0.72);
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-release-main strong {
  overflow: hidden;
  color: #ffffff;
  font-size: 25px;
  font-weight: 900;
  line-height: 1.15;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-release-meter {
  display: grid;
  align-content: center;
  gap: 10px;
}

.criteria-release-meter span,
.criteria-release-meter em {
  overflow: hidden;
  color: rgba(240, 248, 244, 0.74);
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-release-meter .ops-progress-track {
  background: rgba(255, 255, 255, 0.14);
}

.criteria-release-actions .ops-command-button.is-secondary {
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
}

.criteria-ops-matrix {
  grid-template-columns: 302px minmax(420px, 1fr) 276px;
  gap: 0;
  min-height: 520px;
  height: clamp(520px, 100vh - 342px, 760px);
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
}

.criteria-studio-shell .ops-console-list-panel,
.criteria-studio-shell .ops-console-detail-panel,
.criteria-studio-shell .ops-deploy-panel {
  border: 0;
  border-radius: 0;
  box-shadow: none;
}

.criteria-template-rail {
  border-right: 1px solid var(--ops-border-strong) !important;
  background: #f6f8f7 !important;
}

.criteria-spec-stream {
  background: linear-gradient(90deg, rgba(15, 21, 18, 0.025) 1px, transparent 1px), #ffffff !important;
  background-size: 26px 26px !important;
}

.criteria-action-rail {
  border-left: 1px solid var(--ops-border-strong) !important;
  background: #f8faf9 !important;
}

.criteria-studio-shell .ops-console-panel-head,
.criteria-studio-shell .ops-console-filter-stack,
.criteria-studio-shell .ops-console-pagination,
.criteria-studio-shell .ops-detail-header,
.criteria-studio-shell .ops-config-row,
.criteria-studio-shell .ops-deploy-status-block,
.criteria-studio-shell .ops-action-stack {
  border-color: var(--ops-border-strong);
}

.criteria-studio-shell .ops-template-row,
.criteria-studio-shell .ops-action-row,
.criteria-studio-shell .ops-rule-row {
  border-radius: 0;
  box-shadow: none;
}

.criteria-studio-shell .ops-template-row.is-selected {
  background: #111714;
  color: #ffffff;
  box-shadow: none;
}

.criteria-studio-shell .ops-template-row.is-selected strong,
.criteria-studio-shell .ops-template-row.is-selected em,
.criteria-studio-shell .ops-template-row.is-selected small {
  color: #ffffff;
}

.criteria-studio-shell .ops-template-row.is-selected .ops-template-progress i {
  border-color: rgba(255, 255, 255, 0.28);
  background: rgba(255, 255, 255, 0.16);
}

.criteria-studio-shell .ops-template-row.is-selected .ops-template-progress b {
  background: #8ee2aa;
}

.criteria-filter-summary {
  overflow: hidden;
  color: var(--ops-muted-strong);
  font-size: 11px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-detail-scoreboard {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  border-bottom: 1px solid var(--ops-border-strong);
  background: #f8faf9;
}

.criteria-detail-scoreboard div {
  min-width: 0;
  border-right: 1px solid var(--ops-border);
  padding: 11px 14px;
}

.criteria-detail-scoreboard div:last-child {
  border-right: 0;
}

.criteria-detail-scoreboard span,
.criteria-detail-scoreboard em {
  display: block;
  overflow: hidden;
  color: var(--ops-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-detail-scoreboard strong {
  display: block;
  margin-top: 5px;
  overflow: hidden;
  color: var(--ops-heading);
  font-size: 18px;
  font-weight: 900;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-detail-scoreboard em {
  margin-top: 6px;
}

.criteria-studio-shell .ops-config-row {
  grid-template-columns: 156px minmax(0, 1fr);
  padding: 15px 18px;
}

.criteria-studio-shell .ops-config-label span,
.criteria-studio-shell .ops-data-table,
.criteria-studio-shell .ops-structure-table,
.criteria-studio-shell .ops-capture-matrix,
.criteria-studio-shell .ops-config-dl div,
.criteria-studio-shell .ops-deploy-status-block,
.criteria-studio-shell .ops-action-stack {
  border-radius: 0;
  box-shadow: none;
}

.criteria-writer-command {
  margin-bottom: 0;
}

.criteria-studio-shell .ops-wizard-shell {
  border: 1px solid var(--ops-border-strong);
  background: #ffffff;
}

.criteria-studio-shell .ops-wizard-strip,
.criteria-studio-shell .ops-wizard-canvas,
.criteria-studio-shell .ops-wizard-review {
  border-radius: 0;
  box-shadow: none;
}

.criteria-command-line,
.criteria-writer-command {
  border: 1px solid var(--criteria-line);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: var(--criteria-shadow);
  padding: 14px 16px;
}

.criteria-command-line .ops-desk-title h1,
.criteria-writer-command .ops-desk-title h1 {
  color: var(--criteria-ink);
  font-size: 27px !important;
  letter-spacing: 0;
}

.criteria-studio-shell .ops-section-kicker {
  color: var(--criteria-muted);
  letter-spacing: 0;
}

.criteria-studio-shell .ops-inline-meta span,
.criteria-studio-shell .ops-count-label {
  border-color: var(--criteria-line);
  background: var(--criteria-soft);
  color: var(--criteria-muted);
}

.criteria-studio-shell .ops-count-label {
  border-color: var(--criteria-ink);
  background: var(--criteria-ink);
  color: #ffffff;
}

.criteria-studio-shell .ops-command-button,
.criteria-studio-shell .ops-icon-command,
.criteria-studio-shell .ops-console-pagination button {
  border-radius: 8px;
  transition: background-color 140ms ease, border-color 140ms ease, box-shadow 140ms ease, color 140ms ease;
}

.criteria-studio-shell .ops-command-button.is-primary {
  border-color: #10251d;
  background: #10251d;
  color: #ffffff;
  box-shadow: 0 8px 18px rgba(16, 37, 29, 0.16);
}

.criteria-studio-shell .ops-command-button.is-secondary,
.criteria-studio-shell .ops-icon-command,
.criteria-studio-shell .ops-console-pagination button {
  border-color: var(--criteria-line);
  background: rgba(255, 255, 255, 0.92);
  color: var(--criteria-ink);
}

.criteria-studio-shell .ops-command-button:hover,
.criteria-studio-shell .ops-icon-command:hover,
.criteria-studio-shell .ops-console-pagination button:hover:not(:disabled) {
  border-color: var(--criteria-line-strong);
  box-shadow: 0 6px 14px rgba(20, 32, 26, 0.08);
}

.criteria-floating-create {
  position: fixed;
  right: 30px;
  bottom: 30px;
  z-index: 120;
  display: inline-flex;
  width: 58px;
  height: 58px;
  align-items: center;
  justify-content: center;
  border: 1px solid #10251d;
  border-radius: 50%;
  background: #10251d;
  color: #ffffff;
  box-shadow: 0 16px 34px rgba(16, 37, 29, 0.26);
  font-size: 34px;
  font-weight: 700;
  line-height: 1;
  transition: background-color 140ms ease, box-shadow 140ms ease, transform 140ms ease;
}

.criteria-floating-create:hover {
  background: #18372c;
  box-shadow: 0 18px 38px rgba(16, 37, 29, 0.32);
  transform: translateY(-1px);
}

.criteria-kpi-strip {
  gap: 8px;
  border: 0;
  background: transparent;
}

.criteria-kpi-card {
  grid-template-columns: minmax(0, 1fr) auto;
  grid-template-areas: "label value" "note value";
  min-height: 58px;
  align-content: center;
  align-items: center;
  gap: 2px 12px;
  border: 1px solid var(--criteria-line);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 6px 14px rgba(20, 32, 26, 0.045);
  padding: 9px 14px 9px 15px;
}

.criteria-kpi-card:last-child {
  border-right: 1px solid var(--criteria-line);
}

.criteria-kpi-card:hover {
  border-color: var(--criteria-line-strong);
  background: #ffffff;
  box-shadow: 0 8px 18px rgba(20, 32, 26, 0.07);
}

.criteria-kpi-card.is-active {
  border-color: #10251d;
  background: #ffffff;
  box-shadow: inset 3px 0 0 #10251d, 0 8px 18px rgba(20, 32, 26, 0.08);
}

.criteria-kpi-card.is-ready {
  box-shadow: inset 3px 0 0 var(--criteria-green), 0 6px 14px rgba(20, 32, 26, 0.045);
}

.criteria-kpi-card.is-warning {
  box-shadow: inset 3px 0 0 var(--criteria-amber), 0 6px 14px rgba(20, 32, 26, 0.045);
}

.criteria-kpi-card.is-deployed {
  box-shadow: inset 3px 0 0 var(--criteria-blue), 0 6px 14px rgba(20, 32, 26, 0.045);
}

.criteria-kpi-card.is-active.is-ready,
.criteria-kpi-card.is-active.is-warning,
.criteria-kpi-card.is-active.is-deployed {
  box-shadow: inset 3px 0 0 #10251d, 0 8px 18px rgba(20, 32, 26, 0.08);
}

.criteria-kpi-card span {
  grid-area: label;
}

.criteria-kpi-card strong {
  grid-area: value;
  justify-self: end;
  font-size: 20px;
}

.criteria-kpi-card em {
  grid-area: note;
  max-width: 100%;
  font-weight: 800;
}

.criteria-kpi-card strong {
  color: var(--criteria-ink);
}

.criteria-home-grid {
  gap: 14px;
}

.criteria-list-workbench,
.criteria-priority-section,
.criteria-detail-screen,
.criteria-studio-shell .ops-wizard-shell {
  border: 1px solid var(--criteria-line);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: var(--criteria-shadow);
  overflow: hidden;
}

.criteria-priority-panel {
  gap: 14px;
}

.criteria-panel-title {
  min-height: 60px;
  border-bottom: 1px solid var(--criteria-line);
  background: #ffffff;
  padding: 0 18px;
}

.criteria-panel-title h2 {
  color: var(--criteria-ink);
}

.criteria-list-toolbar {
  border-bottom: 1px solid var(--criteria-line);
  background: var(--criteria-soft);
  padding: 14px;
}

.criteria-list-toolbar input,
.criteria-list-toolbar select {
  min-height: 38px;
  border-color: var(--criteria-line-strong);
  border-radius: 8px;
  background: #ffffff;
}

.criteria-list-toolbar input:focus,
.criteria-list-toolbar select:focus {
  border-color: var(--criteria-green);
  box-shadow: 0 0 0 3px rgba(47, 127, 98, 0.14);
  outline: 0;
}

.criteria-list-workbench > .criteria-filter-summary {
  border-bottom: 1px solid var(--criteria-line);
  background: #ffffff;
  color: var(--criteria-muted);
  padding: 10px 14px;
}

.criteria-table-head {
  min-height: 42px;
  border-bottom: 1px solid var(--criteria-line);
  background: #f4f8f6;
  padding: 0 16px;
}

.criteria-table-head span {
  color: #66746c;
}

.criteria-table-row {
  min-height: 82px;
  border-bottom: 1px solid #e4ebe7;
  background: #ffffff;
  padding: 13px 16px;
  transition: background-color 140ms ease, box-shadow 140ms ease;
}

.criteria-table-row:hover {
  background: #fbfdfc;
  box-shadow: inset 3px 0 0 rgba(47, 127, 98, 0.58);
}

.criteria-table-main strong,
.criteria-priority-row strong {
  color: var(--criteria-ink);
  font-size: 14px;
}

.criteria-table-main em,
.criteria-table-date small,
.criteria-table-status small,
.criteria-priority-row span,
.criteria-priority-row em {
  color: var(--criteria-muted);
}

.criteria-table-status .ops-state-pill {
  border-color: #dbe5df;
  background: #f7faf8;
  color: #4f5f56;
}

.criteria-table-status .ops-state-pill.is-work-patrol-setup-required,
.criteria-detail-title-row .ops-state-pill.is-work-patrol-setup-required {
  border-color: #fde68a;
  background: #fffbeb;
  color: #92400e;
}

.criteria-table-status .ops-state-pill.is-work-patrol-scheduled,
.criteria-detail-title-row .ops-state-pill.is-work-patrol-scheduled {
  border-color: #d4d8d5;
  background: #f7faf8;
  color: #46534c;
}

.criteria-table-progress i {
  height: 7px;
  border: 0;
  border-radius: 999px;
  background: #e5ede8;
}

.criteria-table-progress b {
  border-radius: inherit;
  background: linear-gradient(90deg, var(--criteria-green), #4aa07c);
}

.criteria-table-action {
  color: var(--criteria-green);
}

.criteria-priority-section {
  gap: 10px;
  padding-bottom: 14px;
}

.criteria-priority-row {
  border-color: var(--criteria-line);
  border-radius: 8px;
  background: #ffffff;
  padding: 12px;
  transition: background-color 140ms ease, border-color 140ms ease, box-shadow 140ms ease;
}

.criteria-priority-row:hover {
  border-color: var(--criteria-line-strong);
  background: #fbfdfc;
  box-shadow: inset 3px 0 0 var(--criteria-amber);
}

.criteria-detail-hero {
  border-bottom: 1px solid var(--criteria-line);
  background: linear-gradient(90deg, rgba(47, 127, 98, 0.08), rgba(40, 114, 165, 0.045)), #ffffff;
  padding: 16px 18px;
}

.criteria-detail-title h2 {
  color: var(--criteria-ink);
  font-size: 23px !important;
}

.criteria-detail-tabs {
  border-bottom: 1px solid var(--criteria-line);
  background: var(--criteria-soft);
}

.criteria-detail-tabs button {
  border-right-color: var(--criteria-line);
}

.criteria-detail-tabs button.is-active {
  background: #ffffff;
  box-shadow: inset 0 -3px 0 var(--criteria-green);
}

.criteria-detail-scoreboard {
  border-bottom: 1px solid var(--criteria-line);
  background: #ffffff;
}

.criteria-detail-scoreboard div {
  border-right-color: var(--criteria-line);
  background: #fbfdfc;
}

.criteria-release-runway {
  border: 1px solid #10251d;
  border-radius: 8px;
  background: linear-gradient(135deg, rgba(47, 127, 98, 0.22), rgba(40, 114, 165, 0.18)), #10251d;
  box-shadow: 0 12px 26px rgba(16, 37, 29, 0.18);
  overflow: hidden;
}

.criteria-studio-shell .ops-wizard-strip,
.criteria-studio-shell .ops-wizard-canvas,
.criteria-studio-shell .ops-wizard-review,
.criteria-studio-shell .ops-config-label span,
.criteria-studio-shell .ops-data-table,
.criteria-studio-shell .ops-structure-table,
.criteria-studio-shell .ops-capture-matrix,
.criteria-studio-shell .ops-config-dl div,
.criteria-studio-shell .ops-deploy-status-block,
.criteria-studio-shell .ops-action-stack {
  border-radius: 8px;
}

@media (max-width: 1260px) {
  .criteria-release-runway,
  .criteria-command-line,
  .criteria-writer-command {
    grid-template-columns: 1fr;
  }
  .criteria-kpi-strip,
  .criteria-detail-scoreboard,
  .criteria-check-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .criteria-home-grid {
    grid-template-columns: 1fr;
  }
  .criteria-list-toolbar {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .criteria-release-main,
  .criteria-release-meter,
  .criteria-release-actions,
  .criteria-template-rail,
  .criteria-action-rail {
    border-right: 0 !important;
    border-left: 0 !important;
  }
}
@media (max-width: 1100px) {
  .criteria-ops-matrix {
    grid-template-columns: 1fr;
    height: auto;
  }
  .criteria-table-head {
    display: none;
  }
  .criteria-table-row {
    grid-template-columns: minmax(0, 1fr);
    gap: 9px;
  }
  .criteria-table-action {
    justify-self: start;
  }
  .criteria-table-date,
  .criteria-table-status {
    justify-content: start;
    justify-items: start;
    text-align: left;
  }
  .criteria-table-progress {
    justify-self: start;
  }
  .criteria-template-rail,
  .criteria-action-rail {
    border-right: 0 !important;
    border-left: 0 !important;
  }
}
@media (max-width: 720px) {
  .criteria-studio-shell {
    padding: 12px;
  }
  .criteria-floating-create {
    right: 18px;
    bottom: 18px;
    width: 52px;
    height: 52px;
    font-size: 31px;
  }
  .criteria-command-line .ops-desk-title h1,
  .criteria-writer-command .ops-desk-title h1 {
    font-size: 23px !important;
  }
  .criteria-release-actions {
    display: grid;
  }
  .criteria-kpi-strip,
  .criteria-detail-scoreboard,
  .criteria-detail-tabs,
  .criteria-check-grid,
  .criteria-list-toolbar {
    grid-template-columns: 1fr;
  }
  .criteria-detail-hero {
    grid-template-columns: 1fr;
  }
  .criteria-detail-buttons {
    justify-content: stretch;
  }
  .criteria-detail-buttons .ops-command-button {
    width: 100%;
  }
}
.criteria-detail-compact {
  width: 100%;
  max-width: none;
  margin: 0;
  gap: 0;
}

.criteria-detail-compact .criteria-detail-hero {
  grid-template-columns: 42px minmax(0, 1fr) auto;
  gap: 12px;
  min-height: 78px;
  align-items: center;
  background: #ffffff;
  padding: 14px 18px;
}

.criteria-detail-compact .ops-icon-command {
  width: 40px;
  height: 40px;
  min-height: 40px;
}

.criteria-detail-title-row {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.criteria-detail-title-row .ops-section-kicker {
  margin-right: 2px;
}

.criteria-detail-title-row .ops-state-pill {
  min-height: 24px;
  padding: 0 9px;
  font-size: 11px;
}

.criteria-detail-compact .criteria-detail-title h2 {
  display: block;
  margin-top: 5px;
  font-size: 22px !important;
  line-height: 1.25;
  white-space: normal;
}

.criteria-detail-compact .ops-inline-meta {
  margin-top: 7px;
}

.criteria-detail-compact .ops-inline-meta span {
  min-height: 26px;
  padding: 0 9px;
}

.criteria-detail-compact .criteria-detail-buttons {
  gap: 6px;
}

.criteria-detail-compact .criteria-detail-buttons .ops-command-button {
  min-height: 38px;
  padding: 0 13px;
  font-size: 12px;
}

.criteria-detail-summary-bar {
  display: grid;
  grid-template-columns: minmax(300px, 0.32fr) minmax(0, 1fr);
  border-bottom: 1px solid var(--criteria-line);
  background: #fbfdfc;
}

.criteria-detail-progress-card {
  display: grid;
  min-width: 0;
  gap: 8px;
  align-content: center;
  border-right: 1px solid var(--criteria-line);
  padding: 12px 18px;
}

.criteria-detail-progress-card div {
  display: flex;
  min-width: 0;
  align-items: baseline;
  justify-content: space-between;
  gap: 10px;
}

.criteria-detail-progress-card span,
.criteria-detail-progress-card em,
.criteria-detail-quick-stats span,
.criteria-detail-quick-stats em {
  overflow: hidden;
  color: var(--criteria-muted);
  font-size: 12px;
  font-style: normal;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-detail-progress-card strong,
.criteria-detail-quick-stats strong {
  overflow: hidden;
  color: var(--criteria-ink);
  font-size: 18px;
  font-weight: 900;
  line-height: 1.1;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-detail-progress-card i {
  display: block;
  height: 7px;
  overflow: hidden;
  border-radius: 999px;
  background: #e4ece7;
}

.criteria-detail-progress-card b {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, var(--criteria-green), #4aa07c);
}

.criteria-detail-quick-stats {
  display: grid;
  min-width: 0;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.criteria-detail-quick-stats div {
  display: grid;
  min-width: 0;
  gap: 5px;
  align-content: center;
  border-right: 1px solid var(--criteria-line);
  padding: 12px 18px;
}

.criteria-detail-quick-stats div:last-child {
  border-right: 0;
}

.criteria-detail-tabs {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.criteria-detail-compact .criteria-detail-tabs button {
  min-height: 42px;
  padding: 0 14px;
}

.criteria-detail-compact .criteria-detail-tabs button.is-active {
  box-shadow: inset 0 -2px 0 var(--criteria-green);
}

.criteria-detail-compact .criteria-tab-panel {
  gap: 12px;
  padding: 14px;
}

.criteria-summary-compact-grid {
  display: grid;
  grid-template-columns: minmax(360px, 0.72fr) minmax(560px, 1.28fr);
  gap: 12px;
  align-items: start;
}

.criteria-summary-block {
  min-width: 0;
  border: 1px solid var(--criteria-line);
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
}

.criteria-summary-block header {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-bottom: 1px solid var(--criteria-line);
  background: #f7faf8;
  padding: 0 13px;
}

.criteria-summary-block header strong,
.criteria-summary-block header span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-summary-block header strong {
  color: var(--criteria-ink);
  font-size: 14px;
  font-weight: 900;
}

.criteria-summary-block header span {
  color: var(--criteria-muted);
  font-size: 12px;
  font-weight: 900;
}

.criteria-summary-list {
  display: grid;
  margin: 0;
}

.criteria-summary-list div {
  display: grid;
  min-width: 0;
  grid-template-columns: 76px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  min-height: 42px;
  border-bottom: 1px solid #e7eee9;
  padding: 0 13px;
}

.criteria-summary-list div:last-child {
  border-bottom: 0;
}

.criteria-summary-list dt,
.criteria-summary-list dd {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-summary-list dt {
  color: var(--criteria-muted);
  font-size: 12px;
  font-weight: 900;
}

.criteria-summary-list dd {
  margin: 0;
  color: var(--criteria-ink);
  font-size: 13px;
  font-weight: 900;
}

.criteria-check-list {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px;
  padding: 10px;
}

.criteria-check-list .ops-action-row {
  cursor: default;
}

.criteria-tab-block {
  min-width: 0;
  border: 1px solid var(--criteria-line);
  border-radius: 8px;
  background: #ffffff;
  overflow: hidden;
}

.criteria-tab-block-head {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid var(--criteria-line);
  background: #f7faf8;
  padding: 0 13px;
}

.criteria-tab-block-head strong,
.criteria-tab-block-head span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-tab-block-head strong {
  color: var(--criteria-ink);
  font-size: 14px;
  font-weight: 900;
}

.criteria-tab-block-head span {
  color: var(--criteria-muted);
  font-size: 12px;
  font-weight: 900;
}

.criteria-route-panel,
.criteria-capture-panel {
  grid-template-columns: minmax(360px, 0.74fr) minmax(560px, 1.26fr);
  align-items: start;
}

.criteria-launch-list,
.criteria-point-grid,
.criteria-capture-metrics,
.criteria-rule-cards,
.criteria-reference-list {
  display: grid;
  min-width: 0;
  gap: 8px;
  padding: 10px;
}

.criteria-point-grid {
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
}

.criteria-capture-metrics {
  grid-template-columns: repeat(auto-fit, minmax(130px, 1fr));
}

.criteria-rule-cards {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.criteria-launch-card,
.criteria-point-card,
.criteria-rule-card,
.criteria-reference-row,
.criteria-tab-empty {
  min-width: 0;
  border: 1px solid #e2ebe6;
  border-radius: 8px;
  background: #ffffff;
}

.criteria-launch-card {
  display: grid;
  grid-template-columns: minmax(160px, 0.72fr) minmax(220px, 1fr) auto;
  gap: 12px;
  align-items: center;
  padding: 12px;
}

.criteria-card-title,
.criteria-point-head,
.criteria-reference-main {
  display: grid;
  min-width: 0;
  gap: 4px;
}

.criteria-card-title span,
.criteria-point-head span,
.criteria-capture-metrics span,
.criteria-rule-card span,
.criteria-reference-main span,
.criteria-inline-dl dt,
.criteria-point-metrics dt {
  overflow: hidden;
  color: var(--criteria-muted);
  font-size: 11px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-card-title strong,
.criteria-point-head strong,
.criteria-capture-metrics strong,
.criteria-rule-card strong,
.criteria-reference-main strong,
.criteria-inline-dl dd,
.criteria-point-metrics dd {
  overflow: hidden;
  color: var(--criteria-ink);
  font-size: 13px;
  font-weight: 900;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-inline-dl,
.criteria-point-metrics {
  display: grid;
  min-width: 0;
  gap: 6px;
  margin: 0;
}

.criteria-inline-dl {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.criteria-inline-dl div,
.criteria-point-metrics div {
  min-width: 0;
}

.criteria-inline-dl dd,
.criteria-point-metrics dd {
  margin: 3px 0 0;
}

.criteria-point-card {
  display: grid;
  gap: 10px;
  padding: 12px;
}

.criteria-point-head {
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 4px 8px;
}

.criteria-point-head span {
  display: inline-flex;
  min-width: 42px;
  min-height: 24px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #edf5f0;
  color: var(--criteria-green);
  padding: 0 8px;
}

.criteria-point-head em {
  grid-column: 1/-1;
  overflow: hidden;
  color: var(--criteria-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-point-metrics {
  grid-template-columns: repeat(2, minmax(0, 1fr));
  border-top: 1px solid #e8efeb;
  padding-top: 9px;
}

.criteria-capture-metrics div,
.criteria-rule-card {
  display: grid;
  min-width: 0;
  gap: 5px;
  border: 1px solid #e2ebe6;
  border-radius: 8px;
  background: #fbfdfc;
  padding: 12px;
}

.criteria-rule-card {
  background: #ffffff;
}

.criteria-rule-card em {
  overflow: hidden;
  color: var(--criteria-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-reference-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto minmax(110px, 0.22fr);
  gap: 12px;
  align-items: center;
  padding: 11px 12px;
}

.criteria-reference-main em,
.criteria-reference-row small {
  overflow: hidden;
  color: var(--criteria-muted);
  font-size: 11px;
  font-style: normal;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.criteria-reference-row small {
  justify-self: end;
  color: var(--criteria-ink);
  font-weight: 900;
}

.criteria-tab-empty {
  color: var(--criteria-muted);
  font-size: 12px;
  font-weight: 900;
  padding: 16px;
  text-align: center;
}

.criteria-detail-compact .ops-action-row {
  min-height: 46px;
  border-radius: 6px;
  padding: 8px 10px;
}

.criteria-detail-compact .ops-action-row strong {
  font-size: 12px;
}

.criteria-detail-compact .ops-action-row em,
.criteria-detail-compact .ops-action-row small {
  font-size: 11px;
}

.criteria-detail-compact .ops-action-row small {
  padding: 4px 8px;
}

.criteria-detail-compact .ops-config-dl,
.criteria-detail-compact .ops-config-dl.is-compact {
  gap: 6px;
}

.criteria-detail-compact .ops-config-dl > div {
  padding: 7px 8px;
}

.criteria-detail-compact .ops-structure-table.is-scrollable {
  max-height: 300px;
}

.criteria-detail-compact .ops-data-table th,
.criteria-detail-compact .ops-data-table td {
  padding-top: 8px;
  padding-bottom: 8px;
}

@media (max-width: 1100px) {
  .criteria-detail-compact {
    max-width: none;
  }
  .criteria-summary-compact-grid,
  .criteria-route-panel,
  .criteria-capture-panel {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 860px) {
  .criteria-detail-compact .criteria-detail-hero,
  .criteria-detail-summary-bar {
    grid-template-columns: 1fr;
  }
  .criteria-detail-progress-card,
  .criteria-detail-quick-stats div {
    border-right: 0;
  }
  .criteria-detail-quick-stats {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    border-top: 1px solid var(--criteria-line);
  }
  .criteria-launch-card,
  .criteria-reference-row {
    grid-template-columns: 1fr;
  }
  .criteria-reference-row small {
    justify-self: start;
  }
}
@media (max-width: 720px) {
  .criteria-detail-quick-stats,
  .criteria-check-list,
  .criteria-rule-cards,
  .criteria-inline-dl,
  .criteria-point-metrics {
    grid-template-columns: 1fr;
  }
  .criteria-summary-list div {
    grid-template-columns: 58px minmax(0, 1fr);
  }
}`],
})
export class PageVillagesComponent implements OnInit {
    public screenMode: string = 'list';
    public listViewMode: string = 'overview';
    public detailTabId: string = 'summary';
    public selectedVillageCode: string = '';
    public selectedTemplateId: string = '';
    public wizardMode: string = 'idle';
    public activeStepId: string = 'basic';
    public lastActionMessage: string = '';
    public validationMessage: string = '';
    public validationAttemptedStepId: string = '';
    public draftTemplate: any = null;
    public confirmedWizardStepIds: string[] = [];
    public villages: any[] = [];
    public listKeyword: string = '';
    public listSourceFilter: string = 'all';
    public listStatusFilter: string = 'all';
    public listDeployFilter: string = 'all';
    public currentListPage: number = 1;
    public listPageSize: number = 8;

    public purposeOptions: string[] = ['정기 순찰', '재촬영 확인', '민원 대응', '계절 위험 점검'];
    public droneOptions: string[] = ['DJI Mavic 3 Pro', 'DJI Mavic 3 Enterprise', '위즈윙 다목적 드론', '현장 가용 기체 선택'];
    public cycleOptions: string[] = ['매주', '격주', '월 1회', '월 2회', '필요 시'];
    public departmentOptions: string[] = ['자원보전 업무팀', '드론 운용 담당', '공원관리 현장팀', '탐방시설 담당'];
    public pageSizeOptions: number[] = [5, 8];
    public listStatusOptions: any[] = [
        { value: 'all', label: '전체 상태' },
        { value: 'ready', label: workflowStatusLabel('assigned') },
        { value: 'needs', label: workflowStatusLabel('setup') },
        { value: 'draft', label: workflowStatusLabel('setup') }
    ];
    public listSourceOptions: any[] = [
        { value: 'all', label: '전체' }
    ];
    public listDeployOptions: any[] = [
        { value: 'all', label: '전체 배포' },
        { value: 'deployed', label: workflowStatusLabel('assigned') },
        { value: 'not_deployed', label: workflowStatusLabel('setup') }
    ];

    constructor(@Inject( Service)         public service: Service,@Inject( ChangeDetectorRef    )         public ref: ChangeDetectorRef    ) { }

    public async ngOnInit() {
        await this.service.init(this);
        await this.service.auth.allow('/access');
        await this.loadVillagesFromDatabase();
    }

    public get templateRows() {
        const rows = [];
        this.villages.forEach((village) => {
            const templates = village && village.templates ? village.templates : [];
            templates.forEach((template) => {
                rows.push({
                    village: village,
                    villageCode: village.code || template.villageCode || '',
                    villageName: template.villageName || village.name || this.emptyValue(),
                    template: template
                });
            });
        });
        return rows;
    }

    public get filteredTemplateRows() {
        const keyword = (this.listKeyword || '').toString().trim().toLowerCase();
        return this.templateRows.filter((row) => {
            const template = row.template || {};
            const haystack = [
                row.villageName,
                template.name,
                template.purpose,
                template.department,
                template.owner,
                this.templatePointCount(row),
                this.rowReferenceLabel(row),
                template.lastModified,
                template.createdAt,
                template.updatedAt,
                this.rowStatusLabel(row),
                this.rowDeployLabel(row)
            ].join(' ').toLowerCase();
            const matchesKeyword = !keyword || haystack.indexOf(keyword) >= 0;
            const matchesStatus = this.listStatusFilter === 'all' || this.rowStatusKey(row) === this.listStatusFilter;
            const matchesDeploy = this.listDeployFilter === 'all' || this.rowDeployKey(row) === this.listDeployFilter;
            return matchesKeyword && matchesStatus && matchesDeploy;
        });
    }

    public get totalTemplateCount() {
        return this.templateRows.length;
    }

    public get readyTemplateCount() {
        return this.templateRows.filter((row) => this.rowStatusKey(row) === 'ready').length;
    }

    public get needReviewTemplateCount() {
        return this.templateRows.filter((row) => this.rowStatusKey(row) === 'needs').length;
    }

    public get draftTemplateCount() {
        return this.templateRows.filter((row) => this.rowStatusKey(row) === 'draft').length;
    }

    public get deployedTemplateCount() {
        return this.templateRows.filter((row) => this.rowDeployKey(row) === 'deployed').length;
    }

    public get criteriaSummaryCards() {
        return [
            {
                id: 'all',
                label: '전체 기준',
                value: this.totalTemplateCount,
                unit: '건',
                note: `마을 ${this.villages.length}곳`,
                className: 'is-total'
            },
            {
                id: 'ready',
                label: workflowStatusLabel('assigned'),
                value: this.readyTemplateCount,
                unit: '건',
                note: '필수 기준 완료',
                className: 'is-ready'
            },
            {
                id: 'needs',
                label: workflowStatusLabel('setup'),
                value: this.needReviewTemplateCount,
                unit: '건',
                note: `설정 필요 ${this.draftTemplateCount}건`,
                className: 'is-warning'
            },
            {
                id: 'deployed',
                label: workflowStatusLabel('assigned'),
                value: this.deployedTemplateCount,
                unit: '건',
                note: `${this.totalTemplateCount - this.deployedTemplateCount}건 설정 필요`,
                className: 'is-deployed'
            }
        ];
    }

    public get detailTabs() {
        return [
            { id: 'summary', label: '요약', count: this.templateReviewRequiredCount(this.activeTemplate) },
            { id: 'route', label: '지점', count: this.templatePointCount(this.activeTemplate) },
            { id: 'capture', label: '촬영', count: this.captureValueFilledCount(this.activeTemplate) },
            { id: 'reference', label: '사진', count: this.referenceRowsForTemplate(this.activeTemplate).length }
        ];
    }

    public get activeFilterSummary() {
        const filters = [];
        const status = this.listStatusOptions.find((option) => option.value === this.listStatusFilter);
        const deploy = this.listDeployOptions.find((option) => option.value === this.listDeployFilter);
        if (this.listKeyword) filters.push(`검색 ${this.listKeyword}`);
        if (status && status.value !== 'all') filters.push(status.label);
        if (deploy && deploy.value !== 'all') filters.push(deploy.label);
        return filters.length ? filters.join(' · ') : '전체 기준 표시';
    }

    public get listTotalCount() {
        return this.filteredTemplateRows.length;
    }

    public get listTotalPages() {
        return Math.max(1, Math.ceil(this.listTotalCount / this.listPageSizeNumber()));
    }

    public get listCurrentPage() {
        return Math.min(Math.max(1, Number(this.currentListPage) || 1), this.listTotalPages);
    }

    public get pagedTemplateRows() {
        const start = (this.listCurrentPage - 1) * this.listPageSizeNumber();
        return this.filteredTemplateRows.slice(start, start + this.listPageSizeNumber());
    }

    public get listStartIndex() {
        if (!this.listTotalCount) return 0;
        return (this.listCurrentPage - 1) * this.listPageSizeNumber() + 1;
    }

    public get listEndIndex() {
        return Math.min(this.listCurrentPage * this.listPageSizeNumber(), this.listTotalCount);
    }

    public get listPageNumbers() {
        const total = this.listTotalPages;
        const current = this.listCurrentPage;
        const start = Math.max(1, Math.min(current - 2, total - 4));
        const end = Math.min(total, start + 4);
        const pages = [];
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public get activeVillage() {
        return this.villages.find((item) => item.code === this.selectedVillageCode) || this.villages[0] || null;
    }

    public get templateOptions() {
        if (!this.activeVillage) return [];
        return this.activeVillage.templates || [];
    }

    public get selectableVillages() {
        return this.villages.filter((village) => !this.isPlaceholderVillageCode(village && village.code));
    }

    public get activeTemplate() {
        const templates = this.templateOptions;
        return templates.find((item) => this.templateKey(item) === this.selectedTemplateId) || templates[0] || null;
    }

    public get workingTemplate() {
        if (this.wizardMode === 'create' || this.wizardMode === 'edit') return this.draftTemplate;
        return this.activeTemplate;
    }

    public get isEditing() {
        return this.wizardMode === 'create' || this.wizardMode === 'edit';
    }

    public get launchPoints() {
        const template = this.workingTemplate;
        if (template && template.launchPoints) return template.launchPoints;
        if (this.activeVillage && this.activeVillage.launchPoints) return this.activeVillage.launchPoints;
        return [];
    }

    public get pointRows() {
        const template = this.workingTemplate;
        const templatePoints = this.templatePointRows(template);
        if (templatePoints.length) return templatePoints;
        if (this.activeVillage && this.activeVillage.points) return this.activeVillage.points;
        if (this.activeVillage && this.activeVillage.observationPoints) return this.activeVillage.observationPoints;
        return [];
    }

    public get captureRules() {
        const template = this.workingTemplate;
        if (template && template.captureRules && template.captureRules.length) return template.captureRules;
        return [
            { label: '촬영 시간대', value: this.emptyValue(), note: '반복 순찰에 사용할 촬영 시간' },
            { label: '고도 허용 범위', value: this.emptyValue(), note: '관측 포인트별 촬영 높이 범위' },
            { label: '비행 가능 날씨', value: this.emptyValue(), note: '풍속, 강수, 시정 확인 기준' },
            { label: '사진 정리 규칙', value: this.emptyValue(), note: '마을, 관측 포인트, 회차 식별 방식' }
        ];
    }

    public get referencePhotos() {
        const template = this.workingTemplate;
        if (template && template.referencePhotos && template.referencePhotos.length) return template.referencePhotos;
        return this.pointRows
            .filter((point) => point.referencePhoto || point.referencePhotoName || point.photoStatus || point.referenceStatus)
            .map((point) => ({
                point: point.code,
                name: point.name,
                status: point.referenceStatus || point.photoStatus || point.status,
                quality: point.referenceQuality || point.quality,
                updatedAt: point.referenceUpdatedAt || point.photoUpdatedAt || point.updatedAt
            }));
    }

    public get referenceStatusCards() {
        return [
            {
                label: '승인됨',
                value: `${this.referenceCount(['APPROVED', '승인됨'])}건`,
                tone: 'border-emerald-200 bg-emerald-50 text-emerald-800'
            },
            {
                label: '교체 필요',
                value: `${this.referenceCount(['NEEDS_REPLACE', 'REPLACE_REQUIRED', '교체 필요'])}건`,
                tone: 'border-rose-200 bg-rose-50 text-rose-800'
            },
            {
                label: '품질 경고',
                value: `${this.referenceCount(['QUALITY_WARN', 'WARNING', '품질 경고'])}건`,
                tone: 'border-amber-200 bg-amber-50 text-amber-800'
            }
        ];
    }

    public get maintenanceAlerts() {
        const template = this.workingTemplate;
        const directAlerts = template && template.maintenanceAlerts ? template.maintenanceAlerts : [];
        const pointAlerts = this.pointRows
            .filter((point) => this.needsMaintenance(point))
            .map((point) => ({
                title: `${point.code || '관측 포인트'} ${point.name || ''}`.trim(),
                detail: point.maintenanceNote || point.note || this.maintenanceReason(point),
                status: point.status || point.referenceStatus || point.photoStatus
            }));
        return directAlerts.concat(pointAlerts);
    }

    public get requiredChecklist() {
        const template = this.workingTemplate;
        return [
            {
                id: 'village',
                label: '마을 선택',
                state: this.villageChecklistState(template),
                detail: this.selectedVillageLabel(),
                action: this.activeVillage ? '마을과 기준 이름을 확인합니다.' : '마을을 선택합니다.',
                stepId: 'basic'
            },
            {
                id: 'launch',
                label: '이륙 지점',
                state: this.launchChecklistState(template),
                detail: this.launchChecklistDetail(),
                action: '출발 위치와 안전 확인 조건을 보완합니다.',
                stepId: 'launch'
            },
            {
                id: 'points',
                label: '관측 포인트',
                state: this.pointChecklistState(template),
                detail: this.pointChecklistDetail(),
                action: '누락되었거나 확인이 필요한 관측 포인트를 수정합니다.',
                stepId: 'points'
            },
            {
                id: 'capture',
                label: '촬영 기준값',
                state: this.captureChecklistState(template),
                detail: this.captureChecklistDetail(template),
                action: '촬영 시간대, 고도, 날씨, 사진 정리 기준을 채웁니다.',
                stepId: 'capture'
            },
            {
                id: 'reference',
                label: '기준 사진',
                state: this.referenceChecklistState(template),
                detail: this.referenceChecklistDetail(),
                action: '기준 사진을 등록하고 승인합니다.',
                stepId: 'reference'
            },
            {
                id: 'deploy',
                label: '배포',
                state: this.deployChecklistState(),
                detail: this.deployStatusLabel,
                action: this.canDeploy ? '현장 순찰 배포를 실행합니다.' : '배포 전 필수 설정을 먼저 완료합니다.',
                stepId: 'deploy'
            }
        ].map((item) => ({
            id: item.id,
            label: item.label,
            state: item.state,
            status: this.checklistStatusText(item.state),
            detail: item.detail,
            action: item.action,
            stepId: item.stepId
        }));
    }

    public get setupCompleteCount() {
        return this.requiredChecklist.filter((item) => item.state === 'done').length;
    }

    public get setupCompletionPercent() {
        if (!this.requiredChecklist.length) return 0;
        return Math.round((this.setupCompleteCount / this.requiredChecklist.length) * 100);
    }

    public get setupCompletionLabel() {
        return `${this.setupCompletionPercent}%`;
    }

    public get reviewRequiredItems() {
        return this.requiredChecklist.filter((item) => item.state !== 'done');
    }

    public get missingActionItems() {
        return this.requiredChecklist.filter((item) => item.id !== 'deploy' && item.state !== 'done');
    }

    public get nextRecommendedAction() {
        const next = this.reviewRequiredItems[0];
        if (!this.workingTemplate && this.wizardMode !== 'create') return '기준 선택 또는 새 기준 작성';
        if (!next) return workflowStatusLabel('assigned');
        return next.action;
    }

    public get deployAvailabilityLabel() {
        if (!this.workingTemplate) return workflowStatusLabel('setup');
        if (this.isDeployed || this.canDeploy) return workflowStatusLabel('assigned');
        return workflowStatusLabel('setup');
    }

    public get deployBlockerText() {
        if (!this.workingTemplate) return '마을 선택과 기본 정보부터 시작해야 합니다.';
        if (this.isDeployed) return this.workingTemplate.deployTarget || '순찰 실행에 반영되었습니다.';
        if (this.canDeploy) return '필수 설정이 충족되어 현장 순찰에 배포할 수 있습니다.';
        const blocker = this.requiredChecklist.find((item) => item.id !== 'deploy' && item.state !== 'done');
        return blocker ? `${blocker.label}을 먼저 보완하세요.` : '배포 전 상태를 다시 확인하세요.';
    }

    public get deployButtonLabel() {
        if (!this.workingTemplate) return '새 순찰 기준 작성';
        if (this.canDeploy) return '현장 순찰에 배포';
        return '필수 항목 보완';
    }

    public get maintenanceIssueCards() {
        const replaceCount = this.referenceCount(['NEEDS_REPLACE', 'REPLACE_REQUIRED', '교체 필요']);
        const recaptureCount = this.pointCount(['RECAPTURE', '재촬영 반복']);
        const qualityCount = this.pointCount(['QUALITY_WARN', 'WARNING', '품질 경고']) + this.referenceCount(['QUALITY_WARN', 'WARNING', '품질 경고']);
        const inactiveCount = this.pointCount(['INACTIVE', '비활성', '운영 제외']);
        return [
            {
                label: '기준 사진 교체 필요',
                count: replaceCount,
                detail: replaceCount ? `${replaceCount}개 교체` : '교체 없음',
                state: replaceCount ? 'check' : 'done',
                stepId: 'reference'
            },
            {
                label: '재촬영 반복 관측 포인트',
                count: recaptureCount,
                detail: recaptureCount ? `${recaptureCount}개 반복` : '반복 없음',
                state: recaptureCount ? 'check' : 'done',
                stepId: 'points'
            },
            {
                label: '촬영 품질 경고',
                count: qualityCount,
                detail: qualityCount ? `${qualityCount}건 경고` : '경고 없음',
                state: qualityCount ? 'check' : 'done',
                stepId: 'reference'
            },
            {
                label: '운영 제외 관측 포인트',
                count: inactiveCount,
                detail: inactiveCount ? `${inactiveCount}개 제외` : '제외 없음',
                state: inactiveCount ? 'check' : 'done',
                stepId: 'points'
            }
        ];
    }

    public get attentionIssueCards() {
        return this.maintenanceIssueCards.filter((issue) => issue.count > 0);
    }

    public get canSave() {
        return !!this.workingTemplate;
    }

    public get canDeploy() {
        const template = this.workingTemplate;
        return !!template
            && this.hasSelectedVillage(template)
            && this.valueIsSet(template.name)
            && this.hasLaunchPoint(template)
            && this.hasObservationPoint(template)
            && this.hasCaptureRule(template)
            && this.hasApprovedReference(template);
    }

    public get isDeployed() {
        const template = this.workingTemplate;
        if (!template) return false;
        const status = this.normalizeStatus(template.deployStatus);
        return status === 'DEPLOYED' || template.deployStatus === '배포됨';
    }

    public get deployStatusLabel() {
        const template = this.workingTemplate;
        if (!template) return workflowStatusLabel('setup');
        return this.statusLabel(template.deployStatus || 'UNDEPLOYED');
    }

    public get deployHint() {
        if (!this.workingTemplate) return '기준 필요';
        if (this.isDeployed) return this.workingTemplate.deployTarget || '현장 순찰에 반영됨';
        if (this.canDeploy) return '모든 설정이 완료되어 배포할 수 있습니다.';
        return '순찰 설정 필요 단계가 남아 있습니다.';
    }

    public get wizardSteps() {
        const template = this.workingTemplate;
        const base = [
            {
                id: 'basic',
                number: '1',
                label: '마을 선택',
                summary: '마을과 순찰 기준 이름',
                done: this.wizardStepDone('basic', template),
                ready: !!template
            },
            {
                id: 'launch',
                number: '2',
                label: '이륙 지점',
                summary: '출발 위치와 안전 조건',
                done: this.wizardStepDone('launch', template),
                ready: this.wizardStepReady('launch', template)
            },
            {
                id: 'points',
                number: '3',
                label: '관측 포인트',
                summary: '위치와 식별 정보',
                done: this.wizardStepDone('points', template),
                ready: this.wizardStepReady('points', template)
            },
            {
                id: 'capture',
                number: '4',
                label: '촬영 기준값',
                summary: '고도, 방향, 짐벌, 줌',
                done: this.wizardStepDone('capture', template),
                ready: this.wizardStepReady('capture', template)
            },
            {
                id: 'reference',
                number: '5',
                label: '기준 사진',
                summary: '기준 사진과 품질 승인 상태',
                done: this.wizardStepDone('reference', template),
                ready: this.wizardStepReady('reference', template)
            },
            {
                id: 'deploy',
                number: '6',
                label: '배포',
                summary: '운영 기준 반영',
                done: this.wizardStepDone('deploy', template),
                ready: this.wizardStepReady('deploy', template)
            }
        ];
        const firstTodo = base.find((step) => !step.done);
        return base.map((step) => {
            let state = 'waiting';
            if (step.done) state = 'done';
            else if (step.id === this.activeStepId || (firstTodo && firstTodo.id === step.id)) state = step.ready ? 'current' : 'warning';
            else if (step.ready) state = 'warning';
            return {
                id: step.id,
                number: step.number,
                label: step.label,
                summary: step.summary,
                state: state,
                status: this.stepStatusText(step, state)
            };
        });
    }

    public get completedStepCount() {
        return this.wizardSteps.filter((step) => step.state === 'done').length;
    }

    public get completedStepLabel() {
        return `${this.completedStepCount}/${this.wizardSteps.length}단계`;
    }

    public wizardStepDone(stepId: string, template: any) {
        if (this.isEditing) return this.confirmedWizardStepIds.indexOf(stepId) >= 0;
        if (stepId === 'basic') return this.hasBasicInfo(template);
        if (stepId === 'launch') return this.hasLaunchPoint(template);
        if (stepId === 'points') return this.hasObservationPoint(template);
        if (stepId === 'capture') return this.hasCaptureRule(template);
        if (stepId === 'reference') return this.hasApprovedReference(template);
        if (stepId === 'deploy') return this.isDeployed;
        return false;
    }

    public wizardStepReady(stepId: string, template: any) {
        if (!template) return false;
        if (stepId === 'basic') return true;
        if (this.isEditing) {
            if (stepId === 'launch') return this.confirmedWizardStepIds.indexOf('basic') >= 0;
            if (stepId === 'points') return this.confirmedWizardStepIds.indexOf('launch') >= 0;
            if (stepId === 'capture') return this.confirmedWizardStepIds.indexOf('points') >= 0;
            if (stepId === 'reference') return this.confirmedWizardStepIds.indexOf('capture') >= 0;
            if (stepId === 'deploy') return this.confirmedWizardStepIds.indexOf('reference') >= 0;
        }
        if (stepId === 'launch') return this.hasBasicInfo(template);
        if (stepId === 'points') return this.hasLaunchPoint(template);
        if (stepId === 'capture') return this.hasObservationPoint(template);
        if (stepId === 'reference') return this.hasCaptureRule(template);
        if (stepId === 'deploy') return this.hasApprovedReference(template);
        return false;
    }

    public completedStepIdsForTemplate(template: any) {
        const completed = [];
        if (this.hasBasicInfo(template)) completed.push('basic');
        if (this.hasLaunchPoint(template)) completed.push('launch');
        if (this.hasObservationPoint(template)) completed.push('points');
        if (this.hasCaptureRule(template)) completed.push('capture');
        if (this.hasApprovedReference(template)) completed.push('reference');
        const deployStatus = this.normalizeStatus(template && template.deployStatus);
        if (deployStatus === 'DEPLOYED' || (template && template.deployStatus === '배포됨')) completed.push('deploy');
        return completed;
    }

    public confirmWizardStep(stepId: string) {
        if (this.confirmedWizardStepIds.indexOf(stepId) < 0) {
            this.confirmedWizardStepIds = this.confirmedWizardStepIds.concat([stepId]);
        }
    }

    public get nextTaskTitle() {
        const next = this.wizardSteps.find((step) => step.state !== 'done');
        if (!this.workingTemplate && this.wizardMode !== 'create') return '기준 선택 필요';
        if (!next) return workflowStatusLabel('assigned');
        if (next.state === 'warning') return `${workflowStatusLabel('setup')}: ${next.label}`;
        return `${next.label} 진행`;
    }

    public get nextTaskDetail() {
        const next = this.wizardSteps.find((step) => step.state !== 'done');
        if (!this.workingTemplate && this.wizardMode !== 'create') {
            return '기준 선택 또는 새 기준 작성';
        }
        if (!next) return this.workingTemplate?.deployTarget || '순찰 실행에서 사용할 수 있습니다.';
        return next.summary;
    }

    public get summaryCards() {
        return [
            {
                label: '마을',
                value: this.selectedVillageLabel(),
                note: this.activeVillage ? (this.activeVillage.area || '마을 목록에서 선택됨') : '기본 정보에서 직접 입력 가능'
            },
            {
                label: '선택된 순찰 기준',
                value: this.workingTemplate ? this.workingTemplate.name || '이름 입력 중' : '선택 전',
                note: this.workingTemplate ? (this.workingTemplate.version || this.workingTemplate.lastModified || this.modeLabel()) : '새로 작성하거나 목록에서 선택'
            },
            {
                label: '준비 상태',
                value: this.setupCompletionLabel,
                note: `${this.setupCompleteCount}/${this.requiredChecklist.length}개 필수 항목 완료`
            },
            {
                label: '현장 반영',
                value: this.deployAvailabilityLabel,
                note: this.deployBlockerText
            }
        ];
    }

    public get selectedTemplateStats() {
        const template = this.activeTemplate;
        if (!template) return [];
        return [
            {
                label: '완성도',
                value: `${this.templateCompletionPercent(template)}%`,
                note: `누락 ${this.templateReviewRequiredCount(template)}건`
            },
            {
                label: '관측 포인트',
                value: `${this.templatePointCount(template)}개`,
                note: this.pointChecklistDetail()
            },
            {
                label: '기준 사진',
                value: this.rowReferenceLabel(template),
                note: this.referenceChecklistDetail()
            },
            {
                label: '현장 반영',
                value: this.rowDeployLabel(template),
                note: template.lastModified || template.version || '수정 이력 없음'
            }
        ];
    }

    public get editPanelTitle() {
        if (this.wizardMode === 'create') return '새 순찰 기준 작성';
        if (this.wizardMode === 'edit') return '선택한 순찰 기준 수정';
        return '순찰 기준 확인';
    }

    public get editPanelHelp() {
        if (this.isEditing) return '필수 항목 입력';
        return '단계별 상태 확인';
    }

    public get activeStep() {
        return this.wizardSteps.find((step) => step.id === this.activeStepId) || this.wizardSteps[0] || null;
    }

    public get previousStepId() {
        const index = this.wizardSteps.findIndex((step) => step.id === this.activeStepId);
        if (index <= 0) return '';
        return this.wizardSteps[index - 1].id;
    }

    public get nextStepId() {
        const index = this.wizardSteps.findIndex((step) => step.id === this.activeStepId);
        if (index < 0 || index >= this.wizardSteps.length - 1) return '';
        return this.wizardSteps[index + 1].id;
    }

    public get hasPreviousStep() {
        return !!this.previousStepId;
    }

    public get activeStepTitle() {
        const step = this.activeStep;
        return step ? `${step.number}. ${step.label}` : '순찰 기준 작성';
    }

    public get activeStepHelp() {
        const helps: any = {
            basic: '마을과 기준 이름 입력',
            launch: '이륙 지점 입력',
            points: '관측 포인트 입력',
            capture: '촬영 기준값 입력',
            reference: '기준 사진 입력',
            deploy: '반영 및 배포 확인'
        };
        return helps[this.activeStepId] || this.editPanelHelp;
    }

    public get activeStepInstruction() {
        const instructions: any = {
            basic: '순찰 기준을 적용할 마을과 기준 이름만 먼저 정합니다.',
            launch: '드론이 출발할 위치와 현장 안전 확인 내용을 입력합니다.',
            points: '촬영할 관측 지점의 번호, 이름, 위치를 등록합니다.',
            capture: '선택한 관측 지점에서 반복 촬영에 사용할 기준값을 입력합니다.',
            reference: '관측 포인트에 연결할 기준 사진을 등록하고 승인합니다.',
            deploy: '작성 상태를 확인한 뒤 운영 기준으로 반영하거나 현장 순찰 실행에 배포합니다.'
        };
        return instructions[this.activeStepId] || '';
    }

    public get activeStepMissingItems() {
        return this.missingItemsForStep(this.activeStepId);
    }

    public stepMissingCount(stepId: string) {
        if (stepId === 'deploy') {
            return this.wizardSteps.filter((step) => step.id !== 'deploy' && step.state !== 'done').length;
        }
        return this.missingItemsForStep(stepId).length;
    }

    public get activeStepPrimaryLabel() {
        if (this.activeStepId === 'reference') return '승인하고 다음';
        if (this.activeStepId === 'deploy') return this.canDeploy ? '현장 배포' : '누락 항목 확인';
        const next = this.nextStepId ? this.stepLabel(this.nextStepId) : '다음';
        return `다음: ${next}`;
    }

    public templateKey(template: any) {
        return template ? (template.id || template.code || template.name || '') : '';
    }

    public listPageSizeNumber() {
        const size = Number(this.listPageSize) || 8;
        return Math.max(1, size);
    }

    public rowDeployKey(row: any) {
        const template = row && row.template ? row.template : row;
        const deployStatus = this.normalizeStatus(template && template.deployStatus);
        return deployStatus === 'DEPLOYED' || deployStatus === '배포됨' ? 'deployed' : 'not_deployed';
    }

    public rowDeployLabel(row: any) {
        const template = row && row.template ? row.template : row;
        return this.statusLabel(template && (template.deployStatus || 'UNDEPLOYED'));
    }

    public rowStatusKey(row: any) {
        const template = row && row.template ? row.template : row;
        const deployStatus = this.normalizeStatus(template && template.deployStatus);
        if (deployStatus === 'DRAFT' || !template || !template.name) return 'draft';
        if (this.templateReviewRequiredCount(row) > 0) return 'needs';
        return 'ready';
    }

    public rowStatusLabel(row: any) {
        const status = this.rowStatusKey(row);
        if (status === 'draft' || status === 'needs') return workflowStatusLabel('setup');
        return workflowStatusLabel('assigned');
    }

    public rowStatusClass(row: any) {
        const status = this.rowStatusKey(row);
        const key = status === 'ready' ? 'assigned' : 'setup';
        return `${workflowStatusClass(key)} ${key === 'assigned' ? 'is-work-patrol-scheduled' : 'is-work-patrol-setup-required'}`;
    }

    public rowDeployClass(row: any) {
        const key = this.rowDeployKey(row) === 'deployed' ? 'assigned' : 'setup';
        return `${workflowStatusClass(key)} ${key === 'assigned' ? 'is-work-patrol-scheduled' : 'is-work-patrol-setup-required'}`;
    }

    public rowSourceKey(row: any) {
        const template = row && row.template ? row.template : row;
        const value = (template && (template.sourceType || template.scenarioType) || '').toString().toLowerCase();
        if (value === 'demo' || value === 'sample' || value === 'example' || value === 'default') return 'demo';
        return 'custom';
    }

    public rowSourceLabel(row: any) {
        return this.rowSourceKey(row) === 'demo' ? '운영 기준' : '등록 기준';
    }

    public rowSourceClass(row: any) {
        return this.rowSourceKey(row) === 'demo'
            ? 'border-amber-200 bg-amber-50 text-amber-800'
            : 'border-sky-200 bg-sky-50 text-sky-700';
    }

    public templatePointRows(template: any) {
        if (!template) return [];
        if (template.points && Array.isArray(template.points)) return template.points;
        if (template.observationPoints && Array.isArray(template.observationPoints)) return template.observationPoints;
        return [];
    }

    public templateLaunchRows(template: any) {
        if (!template) return [];
        if (template.launchPoints && Array.isArray(template.launchPoints) && template.launchPoints.length) return template.launchPoints;
        if (template.launchName || template.launchCoord || template.launchNote) {
            return [{
                name: template.launchName,
                coord: template.launchCoord,
                note: template.launchNote,
                status: template.launchStatus || 'ACTIVE'
            }];
        }
        return [];
    }

    public captureRulesForTemplate(template: any) {
        if (template && template.captureRules && template.captureRules.length) return template.captureRules;
        return [
            { label: '촬영 시간대', value: template && template.captureTime ? template.captureTime : this.emptyValue(), note: '반복 순찰 시간' },
            { label: '고도 허용 범위', value: template && template.captureAltitudeRange ? template.captureAltitudeRange : this.emptyValue(), note: '관측 포인트별 높이' },
            { label: '비행 가능 날씨', value: template && template.captureWeather ? template.captureWeather : this.emptyValue(), note: '풍속, 강수, 시정' },
            { label: '사진 정리 규칙', value: template && template.captureNaming ? template.captureNaming : this.emptyValue(), note: '파일명과 회차 식별' }
        ];
    }

    public referenceRowsForTemplate(template: any) {
        if (!template) return [];
        if (template.referencePhotos && Array.isArray(template.referencePhotos) && template.referencePhotos.length) return template.referencePhotos;
        if (template.photos && Array.isArray(template.photos) && template.photos.length) return template.photos;
        return this.templatePointRows(template)
            .filter((point) => point.referencePhoto || point.referencePhotoName || point.photoStatus || point.referenceStatus)
            .map((point) => ({
                point: point.code,
                name: point.referencePhoto || point.referencePhotoName || point.name,
                status: point.referenceStatus || point.photoStatus || point.status,
                quality: point.referenceQuality || point.quality,
                updatedAt: point.referenceUpdatedAt || point.photoUpdatedAt || point.updatedAt
            }));
    }

    public firstPointForTemplate(template: any = this.workingTemplate) {
        const points = this.templatePointRows(template);
        return points.length ? points[0] : null;
    }

    public firstLaunchForTemplate(template: any = this.workingTemplate) {
        if (!template || !template.launchPoints || !template.launchPoints.length) return null;
        return template.launchPoints[0];
    }

    public templateReferenceRows(template: any) {
        if (!template) return [];
        if (template.referencePhotos && Array.isArray(template.referencePhotos)) return template.referencePhotos;
        if (template.photos && Array.isArray(template.photos)) return template.photos;
        return [];
    }

    public templatePointCount(row: any) {
        const template = row && row.template ? row.template : row;
        return this.templatePointRows(template).length;
    }

    public rowReferenceLabel(row: any) {
        const template = row && row.template ? row.template : row;
        const photos = this.templateReferenceRows(template);
        if (!photos.length) return '기준 없음';
        const approvedCount = photos.filter((photo) => this.statusLabel(photo.status || photo.referenceStatus || photo.photoStatus) === '승인됨').length;
        const attentionCount = photos.filter((photo) => this.hasAttentionStatus(photo.status || photo.referenceStatus || photo.photoStatus)).length;
        if (attentionCount > 0) return `${workflowStatusLabel('setup')} ${attentionCount}건`;
        if (approvedCount === photos.length) return '승인됨';
        if (approvedCount > 0) return `${approvedCount}/${photos.length} 승인`;
        return '승인 대기';
    }

    public rowReferenceClass(row: any) {
        const label = this.rowReferenceLabel(row);
        if (label === '승인됨') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (label.indexOf(workflowStatusLabel('setup')) >= 0 || label.indexOf('확인 필요') >= 0 || label === '승인 대기') return 'border-amber-200 bg-amber-50 text-amber-700';
        return 'border-zinc-200 bg-zinc-50 text-zinc-600';
    }

    public templateHasVillage(row: any) {
        const template = row && row.template ? row.template : row;
        return !!(row && row.villageName && row.villageName !== this.emptyValue())
            || !!(template && template.villageName)
            || !!(template && template.villageCode && template.villageCode !== '__manual__' && !this.isPlaceholderVillageCode(template.villageCode));
    }

    public templateHasApprovedReference(template: any) {
        const photos = this.templateReferenceRows(template);
        const points = this.templatePointRows(template);
        const targetCount = Math.max(points.length, photos.length);
        if (!targetCount || !photos.length) return false;
        const approvedCount = photos.filter((photo) => this.statusLabel(photo.status || photo.referenceStatus || photo.photoStatus) === '승인됨').length;
        return approvedCount >= targetCount && photos.filter((photo) => this.statusLabel(photo.status || photo.referenceStatus || photo.photoStatus) !== '승인됨').length === 0;
    }

    public templateReviewRequiredCount(row: any) {
        const template = row && row.template ? row.template : row;
        const checks = [
            this.templateHasVillage(row) && !!(template && template.name),
            this.hasLaunchPoint(template),
            this.hasObservationPoint(template),
            this.hasCaptureRule(template),
            this.templateHasApprovedReference(template)
        ];
        return checks.filter((done) => !done).length;
    }

    public templateCompletionPercent(row: any) {
        const total = 5;
        const completed = total - this.templateReviewRequiredCount(row);
        return Math.max(0, Math.min(100, Math.round((completed / total) * 100)));
    }

    public templateMissingLabels(row: any) {
        const template = row && row.template ? row.template : row;
        const checks = [
            { label: '기본', done: this.templateHasVillage(row) && !!(template && template.name) },
            { label: '이륙', done: this.hasLaunchPoint(template) },
            { label: '포인트', done: this.hasObservationPoint(template) },
            { label: '촬영', done: this.hasCaptureRule(template) },
            { label: '사진', done: this.templateHasApprovedReference(template) }
        ];
        const missing = checks.filter((item) => !item.done).map((item) => item.label);
        return missing.length ? missing.join(', ') : '누락 없음';
    }

    public templateLastUpdated(row: any) {
        const template = row && row.template ? row.template : row;
        return (template && (template.lastModified || template.version)) || '수정 이력 없음';
    }

    public compactDate(value: any) {
        const text = (value || '').toString().trim();
        if (!text) return this.emptyValue();
        const matched = text.match(/^(\d{4})-(\d{2})-(\d{2})/);
        if (matched) return `${matched[1].slice(2)}.${matched[2]}.${matched[3]}`;
        return text;
    }

    public templateCreatedDate(row: any) {
        const template = row && row.template ? row.template : row;
        return this.compactDate(template && (template.createdAt || template.created || template.createdDate));
    }

    public templateUpdatedDate(row: any) {
        const template = row && row.template ? row.template : row;
        return this.compactDate(template && (template.updatedAt || template.updated || template.lastModified));
    }

    public summaryCardClass(card: any) {
        const classes = [card.className || ''];
        if (card.id === 'all' && this.listStatusFilter === 'all' && this.listDeployFilter === 'all' && this.listSourceFilter === 'all') classes.push('is-active');
        if (card.id === 'ready' && this.listStatusFilter === 'ready') classes.push('is-active');
        if (card.id === 'needs' && this.listStatusFilter === 'needs') classes.push('is-active');
        if (card.id === 'deployed' && this.listDeployFilter === 'deployed') classes.push('is-active');
        return classes.join(' ');
    }

    public pageButtonClass(page: number) {
        if (page === this.listCurrentPage) return 'border-zinc-900 bg-zinc-900 text-white';
        return 'border-zinc-200 bg-white text-zinc-700 hover:bg-zinc-50';
    }

    public isSelectedTemplateRow(row: any) {
        const selectedKey = this.templateKey(this.activeTemplate);
        const rowKey = this.templateKey(row && row.template ? row.template : row);
        return !!selectedKey && selectedKey === rowKey;
    }

    public selectedTemplateRowClass(row: any) {
        if (this.isSelectedTemplateRow(row)) return 'bg-emerald-50/70 ring-1 ring-inset ring-emerald-200';
        return 'hover:bg-zinc-50';
    }

    public emptyValue() {
        return '미설정';
    }

    public isPlaceholderVillageCode(code: any) {
        const value = (code || '').toString();
        return value === '__unspecified__' || value.indexOf('manual-') === 0;
    }

    public modeLabel() {
        if (this.wizardMode === 'create') return '새 순찰 기준 작성 중';
        if (this.wizardMode === 'edit') return '수정 중';
        return '선택 상태';
    }

    public selectedVillageLabel() {
        const template = this.workingTemplate;
        if (template && template.villageName) return template.villageName;
        if (this.activeVillage && !this.isPlaceholderVillageCode(this.activeVillage.code)) return this.activeVillage.name;
        return '마을 선택 전';
    }

    public showManualVillageInput() {
        if (!this.draftTemplate) return false;
        return !this.selectableVillages.length || this.draftTemplate.villageCode === '__manual__';
    }

    public formatValue(value: any) {
        if (value === 0) return '0';
        return value || this.emptyValue();
    }

    public formatAltitude(point: any) {
        if (point.altitudeLabel) return point.altitudeLabel;
        if (point.altitude || point.altitude === 0) return `${point.altitude}m`;
        return this.emptyValue();
    }

    public formatHeading(point: any) {
        return point.heading || point.direction || this.emptyValue();
    }

    public formatGimbal(point: any) {
        return point.gimbal || point.gimbalAngle || this.emptyValue();
    }

    public formatZoom(point: any) {
        return point.zoom || point.zoomRatio || this.emptyValue();
    }

    public pointReferenceLabel(point: any) {
        return point.referencePhoto || point.referencePhotoName || point.referenceLabel || '등록 전';
    }

    public referenceApprovalLabel() {
        const template = this.workingTemplate;
        if (template && template.approvalStatusLabel) return template.approvalStatusLabel;
        if (template && template.approvalStatus) return this.statusLabel(template.approvalStatus);
        if (!this.referencePhotos.length) return '등록 전';
        const warn = this.referenceCount(['QUALITY_WARN', 'WARNING', '품질 경고']);
        const replace = this.referenceCount(['NEEDS_REPLACE', 'REPLACE_REQUIRED', '교체 필요']);
        const approved = this.referenceCount(['APPROVED', '승인됨']);
        if (warn > 0) return '품질 경고';
        if (replace > 0) return '교체 필요';
        if (approved === this.referencePhotos.length) return '승인됨';
        return '승인 대기';
    }

    public referenceCount(statuses: string[]) {
        return this.referencePhotos.filter((item) => statuses.indexOf(this.normalizeStatus(item.status)) >= 0 || statuses.indexOf(item.status) >= 0).length;
    }

    public normalizeStatus(status: any) {
        return (status || '').toString().trim().toUpperCase();
    }

    public statusLabel(status: any) {
        const value = this.normalizeStatus(status);
        if (value === 'APPROVED') return '승인됨';
        if (value === 'NEEDS_REPLACE' || value === 'REPLACE_REQUIRED') return '교체 필요';
        if (value === 'QUALITY_WARN' || value === 'WARNING') return '품질 경고';
        if (value === 'INACTIVE' || value === '비활성') return '운영 제외';
        if (value === 'RECAPTURE') return '재촬영 반복';
        if (value === 'OVERDUE') return '기한 초과';
        if (value === 'DEPLOYED' || value === 'READY') return workflowStatusLabel('assigned');
        if (value === '배포됨' || value === '배포 가능' || value === '현장배포' || value === '현장 배포') return workflowStatusLabel('assigned');
        if (value === 'UNDEPLOYED' || value === 'NOT_DEPLOYED') return workflowStatusLabel('setup');
        if (value === '미배포' || value === '보완 필요') return workflowStatusLabel('setup');
        if (value === 'ACTIVE') return '운영';
        if (value === 'NORMAL') return '정상';
        if (value === 'DRAFT' || value === '작성 중') return workflowStatusLabel('setup');
        if (value === 'PENDING') return '승인 대기';
        if (value === '확인 필요') return workflowStatusLabel('setup');
        if (value === 'NEEDS_CHECK') return workflowStatusLabel('setup');
        return status || '상태 없음';
    }

    public needsMaintenance(point: any) {
        const status = this.normalizeStatus(point.status || point.referenceStatus || point.photoStatus);
        return ['RECAPTURE', 'QUALITY_WARN', 'WARNING', 'INACTIVE', 'NEEDS_REPLACE', 'REPLACE_REQUIRED', 'OVERDUE'].indexOf(status) >= 0;
    }

    public maintenanceReason(point: any) {
        const status = this.normalizeStatus(point.status || point.referenceStatus || point.photoStatus);
        if (status === 'RECAPTURE') return '재촬영이 반복되는 관측 포인트입니다.';
        if (status === 'QUALITY_WARN' || status === 'WARNING') return '촬영 품질 경고가 있습니다.';
        if (status === 'INACTIVE') return '운영 제외 관측 포인트로 배포 전 확인이 필요합니다.';
        if (status === 'NEEDS_REPLACE' || status === 'REPLACE_REQUIRED') return '기준 사진 교체가 필요합니다.';
        if (status === 'OVERDUE') return '정기 유지보수 기한이 지났습니다.';
        return '유지보수 확인이 필요합니다.';
    }

    public requiredCaptureLabels() {
        return ['촬영 시간대', '고도 허용 범위', '비행 가능 날씨', '사진 정리 규칙'];
    }

    public valueIsSet(value: any) {
        if (value === 0) return true;
        const text = (value || '').toString().trim();
        return !!text && text !== this.emptyValue();
    }

    public stepFieldDefinitions(stepId: string) {
        const fields: any = {
            basic: [
                { id: 'village', label: '마을', message: '마을을 선택하거나 직접 입력하세요.' },
                { id: 'villageName', label: '마을명', message: '마을명을 입력하세요.' },
                { id: 'name', label: '순찰 기준 이름', message: '순찰 기준 이름을 입력하세요.' }
            ],
            launch: [
                { id: 'launchName', label: '이륙 지점', message: '이륙 지점을 입력하세요.' },
                { id: 'launchCoord', label: '좌표/위치', message: '좌표 또는 위치를 입력하세요.' },
                { id: 'launchNote', label: '안전 확인 내용', message: '안전 확인 내용을 입력하세요.' }
            ],
            points: [
                { id: 'pointCode', label: '관측 포인트 번호', message: '관측 포인트 번호를 입력하세요.' },
                { id: 'pointName', label: '관측 포인트 이름', message: '관측 포인트 이름을 입력하세요.' },
                { id: 'pointCoord', label: '관측 포인트 위치', message: '관측 포인트 위치를 입력하세요.' }
            ],
            capture: [
                { id: 'pointAltitude', label: '기준 고도', message: '촬영 기준 고도를 입력하세요.' },
                { id: 'pointHeading', label: '촬영 방향', message: '촬영 방향을 입력하세요.' },
                { id: 'pointGimbal', label: '짐벌 각도', message: '짐벌 각도를 입력하세요.' },
                { id: 'pointZoom', label: '줌 배율', message: '줌 배율을 입력하세요.' },
                { id: 'captureTime', label: '촬영 시간대', message: '촬영 시간대를 입력하세요.' },
                { id: 'captureAltitudeRange', label: '고도 허용 범위', message: '고도 허용 범위를 입력하세요.' },
                { id: 'captureWeather', label: '비행 가능 날씨', message: '비행 가능 날씨 기준을 입력하세요.' },
                { id: 'captureNaming', label: '사진 정리 규칙', message: '사진 정리 규칙을 입력하세요.' }
            ],
            reference: [
                { id: 'referencePoint', label: '관측 포인트', message: '기준 사진을 연결할 관측 포인트를 입력하세요.' },
                { id: 'referenceName', label: '기준 사진명', message: '기준 사진명을 입력하세요.' }
            ]
        };
        if (stepId === 'deploy') {
            return [
                { id: 'step-basic', label: '마을 선택', message: '마을 선택 단계를 완료하세요.' },
                { id: 'step-launch', label: '이륙 지점', message: '이륙 지점 단계를 완료하세요.' },
                { id: 'step-points', label: '관측 포인트', message: '관측 포인트 단계를 완료하세요.' },
                { id: 'step-capture', label: '촬영 기준값', message: '촬영 기준값 단계를 완료하세요.' },
                { id: 'step-reference', label: '기준 사진', message: '기준 사진 단계를 완료하세요.' }
            ];
        }
        return fields[stepId] || [];
    }

    public fieldIsFilled(fieldId: string) {
        const template = this.draftTemplate || this.workingTemplate || {};
        const launch = this.firstLaunchForTemplate(template) || {};
        const point = this.firstPointForTemplate(template) || {};
        if (fieldId.indexOf('step-') === 0) {
            const stepId = fieldId.replace('step-', '');
            return this.wizardStepDone(stepId, template);
        }
        if (fieldId === 'village') {
            return !!((template.villageCode && template.villageCode !== '__manual__') || template.villageName);
        }
        if (fieldId === 'villageName') {
            if (!this.draftTemplate || this.draftTemplate.villageCode !== '__manual__') return true;
            return this.valueIsSet(this.draftTemplate.villageName);
        }
        if (fieldId === 'department') return this.valueIsSet(template.department || template.owner);
        if (fieldId === 'launchName') return this.valueIsSet(template.launchName || launch.name);
        if (fieldId === 'launchCoord') return this.valueIsSet(template.launchCoord || launch.coord || launch.coordinate);
        if (fieldId === 'launchNote') return this.valueIsSet(template.launchNote || launch.note || launch.safetyNote);
        if (fieldId === 'pointCode') return this.valueIsSet(template.pointCode || point.code);
        if (fieldId === 'pointName') return this.valueIsSet(template.pointName || point.name);
        if (fieldId === 'pointCoord') return this.valueIsSet(template.pointCoord || point.coord || point.coordinate);
        if (fieldId === 'pointAltitude') return this.valueIsSet(template.pointAltitude || point.altitude);
        if (fieldId === 'pointHeading') return this.valueIsSet(template.pointHeading || point.heading || point.direction);
        if (fieldId === 'pointGimbal') return this.valueIsSet(template.pointGimbal || point.gimbal || point.gimbalAngle);
        if (fieldId === 'pointZoom') return this.valueIsSet(template.pointZoom || point.zoom || point.zoomRatio);
        if (fieldId === 'captureTime') return this.valueIsSet(template.captureTime || this.captureRuleValue('촬영 시간대', template));
        if (fieldId === 'captureAltitudeRange') return this.valueIsSet(template.captureAltitudeRange || this.captureRuleValue('고도 허용 범위', template));
        if (fieldId === 'captureWeather') return this.valueIsSet(template.captureWeather || this.captureRuleValue('비행 가능 날씨', template));
        if (fieldId === 'captureNaming') return this.valueIsSet(template.captureNaming || this.captureRuleValue('사진 정리 규칙', template));
        if (fieldId === 'referencePoint') return this.valueIsSet(template.referencePoint) || !!this.referencePhotos.length;
        if (fieldId === 'referenceName') return this.valueIsSet(template.referenceName) || !!this.referencePhotos.length;
        return this.valueIsSet(template[fieldId]);
    }

    public missingItemsForStep(stepId: string) {
        return this.stepFieldDefinitions(stepId).filter((field) => !this.fieldIsFilled(field.id));
    }

    public stepMissingMessage(stepId: string) {
        const missing = this.missingItemsForStep(stepId);
        if (!missing.length) return '';
        return `${this.stepLabel(stepId)} 필요: ${missing.map((item) => item.label).join(', ')}`;
    }

    public fieldMissingText(fieldId: string) {
        const field = this.stepFieldDefinitions(this.activeStepId).find((item) => item.id === fieldId);
        return field ? field.message : '필수 항목을 입력하세요.';
    }

    public shouldShowMissing(fieldId: string) {
        return this.validationAttemptedStepId === this.activeStepId && !this.fieldIsFilled(fieldId);
    }

    public hasSelectedVillage(template: any) {
        if (!template) return false;
        return !!((template.villageCode && template.villageCode !== '__manual__' && !this.isPlaceholderVillageCode(template.villageCode)) || template.villageName);
    }

    public hasDepartment(template: any) {
        return !!(template && (template.department || template.owner));
    }

    public rawCaptureRules(template: any = this.workingTemplate) {
        return template && template.captureRules && template.captureRules.length ? template.captureRules : [];
    }

    public captureRuleValue(label: string, template: any = this.workingTemplate) {
        const rule = this.rawCaptureRules(template).find((item) => item.label === label);
        return rule ? rule.value : '';
    }

    public captureFilledCount(template: any = this.workingTemplate) {
        return this.requiredCaptureLabels().filter((label) => this.valueIsSet(this.captureRuleValue(label, template))).length;
    }

    public pointCaptureFieldsFilledCount(template: any = this.workingTemplate) {
        const point = this.firstPointForTemplate(template);
        const values = [
            template && template.pointAltitude,
            point && point.altitude,
            template && template.pointHeading,
            point && (point.heading || point.direction),
            template && template.pointGimbal,
            point && (point.gimbal || point.gimbalAngle),
            template && template.pointZoom,
            point && (point.zoom || point.zoomRatio)
        ];
        return [
            values[0] || values[1],
            values[2] || values[3],
            values[4] || values[5],
            values[6] || values[7]
        ].filter((value) => this.valueIsSet(value)).length;
    }

    public captureValueFilledCount(template: any = this.workingTemplate) {
        return this.pointCaptureFieldsFilledCount(template) + this.captureFilledCount(template);
    }

    public requiredCaptureValueCount() {
        return 4 + this.requiredCaptureLabels().length;
    }

    public referenceTargetCount() {
        return Math.max(this.pointRows.length, this.referencePhotos.length);
    }

    public approvedReferenceCount() {
        return this.referenceCount(['APPROVED', '승인됨']);
    }

    public statusMatches(status: any, statuses: string[]) {
        return statuses.indexOf(this.normalizeStatus(status)) >= 0 || statuses.indexOf(status) >= 0;
    }

    public pointStatusValues(point: any) {
        return [point.status, point.referenceStatus, point.photoStatus, point.maintenanceStatus];
    }

    public pointCount(statuses: string[]) {
        return this.pointRows.filter((point) => this.pointStatusValues(point).some((status) => this.statusMatches(status, statuses))).length;
    }

    public hasAttentionStatus(status: any) {
        return this.statusMatches(status, [
            'RECAPTURE',
            'QUALITY_WARN',
            'WARNING',
            'INACTIVE',
            'NEEDS_REPLACE',
            'REPLACE_REQUIRED',
            'OVERDUE',
            'NEEDS_CHECK',
            'PENDING',
            '재촬영 반복',
            '품질 경고',
            '비활성',
            '운영 제외',
            '교체 필요',
            '확인 필요',
            '승인 대기'
        ]);
    }

    public pointNeedsAttention(point: any) {
        return this.pointStatusValues(point).some((status) => this.hasAttentionStatus(status));
    }

    public checklistStatusText(state: string) {
        if (state === 'done') return '완료';
        if (state === 'check') return workflowStatusLabel('setup');
        return '미설정';
    }

    public villageChecklistState(template: any) {
        return this.hasSelectedVillage(template) ? 'done' : 'unset';
    }

    public launchChecklistState(template: any) {
        const launchPoints = template && template.launchPoints ? template.launchPoints : this.launchPoints;
        if (!launchPoints.length) return 'unset';
        return launchPoints.some((point) => this.hasAttentionStatus(point.status)) ? 'check' : 'done';
    }

    public launchChecklistDetail() {
        if (!this.launchPoints.length) return '이륙 지점 미등록';
        const attentionCount = this.launchPoints.filter((point) => this.hasAttentionStatus(point.status)).length;
        if (attentionCount) return `${this.launchPoints.length}개 등록, ${attentionCount}개 설정 필요`;
        return `${this.launchPoints.length}개 등록 완료`;
    }

    public pointChecklistState(template: any) {
        const points = template && template.points ? template.points : this.pointRows;
        if (!points.length) return 'unset';
        return points.some((point) => this.pointNeedsAttention(point)) ? 'check' : 'done';
    }

    public pointChecklistDetail() {
        if (!this.pointRows.length) return '관측 포인트 미등록';
        const attentionCount = this.pointRows.filter((point) => this.pointNeedsAttention(point)).length;
        if (attentionCount) return `${this.pointRows.length}개 중 ${attentionCount}개 설정 필요`;
        return `${this.pointRows.length}개 등록 완료`;
    }

    public captureChecklistState(template: any) {
        if (!template) return 'unset';
        const filledCount = this.captureValueFilledCount(template);
        if (!filledCount) return 'unset';
        return filledCount === this.requiredCaptureValueCount() ? 'done' : 'check';
    }

    public captureChecklistDetail(template: any) {
        return `${this.captureValueFilledCount(template)}/${this.requiredCaptureValueCount()}개 기준값 입력`;
    }

    public referenceChecklistState(template: any) {
        const photos = template && template.referencePhotos && template.referencePhotos.length ? template.referencePhotos : this.referencePhotos;
        if (!photos.length) return 'unset';
        if (this.approvedReferenceCount() < this.referenceTargetCount()) return 'check';
        if (this.referenceCount(['NEEDS_REPLACE', 'REPLACE_REQUIRED', 'QUALITY_WARN', 'WARNING', '교체 필요', '품질 경고', 'PENDING', '승인 대기']) > 0) return 'check';
        return 'done';
    }

    public referenceChecklistDetail() {
        const targetCount = this.referenceTargetCount();
        if (!targetCount) return '기준 사진 미등록';
        return `승인 ${this.approvedReferenceCount()}/${targetCount}`;
    }

    public departmentChecklistState(template: any) {
        return this.hasDepartment(template) ? 'done' : 'unset';
    }

    public departmentChecklistDetail(template: any) {
        return template && (template.department || template.owner) ? (template.department || template.owner) : '담당 부서 미지정';
    }

    public deployChecklistState() {
        if (this.isDeployed) return 'done';
        if (this.canDeploy) return 'check';
        return 'unset';
    }

    public checklistItemClass(item: any) {
        if (item.state === 'done') return 'border-emerald-200 bg-emerald-50 text-emerald-900';
        if (item.state === 'check') return 'border-amber-200 bg-amber-50 text-amber-950';
        return 'border-zinc-200 bg-white text-zinc-700';
    }

    public checklistBadgeClass(item: any) {
        if (item.state === 'done') return 'border-emerald-200 bg-white text-emerald-700';
        if (item.state === 'check') return 'border-amber-200 bg-white text-amber-700';
        return 'border-zinc-200 bg-zinc-50 text-zinc-500';
    }

    public maintenanceIssueClass(issue: any) {
        if (issue.state === 'done') return 'border-emerald-200 bg-emerald-50 text-emerald-800';
        return 'border-amber-200 bg-amber-50 text-amber-900';
    }

    public deployAvailabilityClass() {
        return workflowStatusClass(this.deployAvailabilityLabel === workflowStatusLabel('assigned') ? 'assigned' : 'setup');
    }

    public stepStatusText(step: any, state: string) {
        if (state === 'done') {
            if (step.id === 'launch') return `${this.launchPoints.length}곳 완료`;
            if (step.id === 'points') return `${this.pointRows.length}개 완료`;
            if (step.id === 'reference') return '승인됨';
            if (step.id === 'deploy') return workflowStatusLabel('assigned');
            return '완료';
        }
        if (!this.workingTemplate) return step.id === 'basic' ? '작성 필요' : '대기';
        if (!step.ready) return '이전 단계 필요';
        if (step.id === 'deploy') return this.canDeploy ? workflowStatusLabel('assigned') : workflowStatusLabel('setup');
        const missingCount = this.stepMissingCount(step.id);
        return missingCount ? `누락 ${missingCount}` : workflowStatusLabel('setup');
    }

    public stepClass(step: any) {
        if (step.state === 'done') return 'border-emerald-200 bg-emerald-50 text-emerald-900';
        if (step.state === 'current') return 'border-sky-300 bg-sky-50 text-sky-950 ring-1 ring-sky-200';
        if (step.state === 'warning') return 'border-amber-200 bg-amber-50 text-amber-950';
        return 'border-zinc-200 bg-white text-zinc-600';
    }

    public stepNumberClass(step: any) {
        if (step.state === 'done') return 'bg-emerald-700 text-white';
        if (step.state === 'current') return 'bg-sky-700 text-white';
        if (step.state === 'warning') return 'bg-amber-500 text-white';
        return 'bg-zinc-100 text-zinc-500';
    }

    public stepBadgeClass(step: any) {
        if (step.state === 'done') return 'border-emerald-200 bg-white text-emerald-700';
        if (step.state === 'current') return 'border-sky-200 bg-white text-sky-700';
        if (step.state === 'warning') return 'border-amber-200 bg-white text-amber-700';
        return 'border-zinc-200 bg-zinc-50 text-zinc-500';
    }

    public approvalClass(status: any) {
        const label = this.statusLabel(status);
        if (label === '승인됨') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (label === '교체 필요') return 'border-rose-200 bg-rose-50 text-rose-700';
        if (label === '품질 경고' || label === workflowStatusLabel('setup') || label === '확인 필요' || label === '승인 대기') return 'border-amber-200 bg-amber-50 text-amber-700';
        return 'border-zinc-200 bg-zinc-50 text-zinc-600';
    }

    public pointStatusClass(status: any) {
        const value = this.normalizeStatus(status);
        if (value === 'ACTIVE' || value === 'NORMAL' || value === 'APPROVED') return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        if (value === 'QUALITY_WARN' || value === 'WARNING' || value === 'RECAPTURE' || value === 'NEEDS_CHECK' || value === 'PENDING') return 'border-amber-200 bg-amber-50 text-amber-700';
        if (value === 'INACTIVE' || value === 'NEEDS_REPLACE' || value === 'REPLACE_REQUIRED' || value === 'OVERDUE') return 'border-rose-200 bg-rose-50 text-rose-700';
        return 'border-zinc-200 bg-zinc-50 text-zinc-600';
    }

    public hasBasicInfo(template: any) {
        if (!template) return false;
        return this.hasSelectedVillage(template) && this.valueIsSet(template.name);
    }

    public hasLaunchPoint(template: any) {
        if (!template || !template.launchPoints || !template.launchPoints.length) return false;
        return !template.launchPoints.some((point) => this.hasAttentionStatus(point.status));
    }

    public hasObservationPoint(template: any) {
        const points = this.templatePointRows(template);
        if (!points.length) return false;
        return !points.some((point) => this.pointNeedsAttention(point));
    }

    public hasCaptureRule(template: any) {
        return !!template && this.captureValueFilledCount(template) === this.requiredCaptureValueCount();
    }

    public hasApprovedReference(template: any) {
        if (!template || !template.referencePhotos || !template.referencePhotos.length) return false;
        const targetCount = this.referenceTargetCount();
        if (!targetCount) return false;
        return this.approvedReferenceCount() >= targetCount
            && template.referencePhotos.filter((photo) => this.statusLabel(photo.status) !== '승인됨').length === 0;
    }

    public firstIncompleteStepId() {
        const step = this.wizardSteps.find((item) => item.state !== 'done');
        return step ? step.id : 'deploy';
    }

    public cloneTemplate(template: any) {
        return JSON.parse(JSON.stringify(template || {}));
    }

    public normalizeVillages(villages: any[]) {
        return (villages || []).map((village) => ({
            code: village.code || '',
            name: village.name || '마을 미선택',
            area: village.area || '',
            status: village.status || 'ACTIVE',
            templates: village.templates || []
        }));
    }

    public selectFirstLoadedTemplate() {
        const firstVillage = this.villages.find((village) => village.templates && village.templates.length) || null;
        const firstTemplate = firstVillage && firstVillage.templates ? firstVillage.templates[0] : null;
        this.selectedVillageCode = firstVillage ? firstVillage.code : '';
        this.selectedTemplateId = firstTemplate ? this.templateKey(firstTemplate) : '';
        this.confirmedWizardStepIds = firstTemplate ? this.completedStepIdsForTemplate(firstTemplate) : [];
    }

    public async loadVillagesFromDatabase() {
        try {
            const response: any = await wiz.call('load', {}, { timeout: 15000 });
            const { code, data } = response || {};
            if (code === 200) {
                this.villages = this.normalizeVillages((data && data.villages) || []);
                this.selectFirstLoadedTemplate();
            } else {
                this.lastActionMessage = (data && data.message) || '등록된 순찰 기준을 불러오지 못했습니다.';
            }
        } catch (error) {
            this.lastActionMessage = '등록된 순찰 기준을 불러오는 중 오류가 발생했습니다.';
        }
        await this.service.render();
    }

    public upsertLocalTemplate(template: any) {
        if (!template) return null;
        const saved = this.cloneTemplate(template);
        const templateId = this.templateKey(saved) || `template-${Date.now()}`;
        saved.id = templateId;

        this.villages.forEach((village) => {
            village.templates = (village.templates || []).filter((item) => this.templateKey(item) !== templateId);
        });

        const realVillageCode = saved.villageCode && saved.villageCode !== '__manual__' && !this.isPlaceholderVillageCode(saved.villageCode)
            ? saved.villageCode
            : '';
        const groupCode = realVillageCode || (saved.villageName ? `manual-${templateId}` : '__unspecified__');
        const groupName = saved.villageName || (realVillageCode ? realVillageCode : '마을 미선택');
        let village = this.villages.find((item) => item.code === groupCode);

        if (!village) {
            village = {
                code: groupCode,
                name: groupName,
                area: realVillageCode ? '' : '작성 중',
                status: realVillageCode ? 'ACTIVE' : 'NEEDS_CHECK',
                templates: []
            };
            this.villages = this.villages.concat([village]);
        }

        village.name = groupName;
        village.templates = (village.templates || []).concat([saved]);
        this.selectedVillageCode = village.code;
        this.selectedTemplateId = this.templateKey(saved);
        return saved;
    }

    public removeLocalTemplate(templateId: string) {
        if (!templateId) return;
        this.villages = this.villages
            .map((village) => ({
                ...village,
                templates: (village.templates || []).filter((item) => this.templateKey(item) !== templateId)
            }))
            .filter((village) => (village.templates || []).length);

        const firstRow = this.templateRows[0] || null;
        this.selectedVillageCode = firstRow ? firstRow.villageCode : '';
        this.selectedTemplateId = firstRow ? this.templateKey(firstRow.template) : '';
        this.wizardMode = firstRow ? 'view' : 'idle';
        this.listViewMode = 'overview';
        this.draftTemplate = null;
        this.confirmedWizardStepIds = firstRow ? this.completedStepIdsForTemplate(firstRow.template) : [];
        this.activeStepId = firstRow ? this.firstIncompleteStepId() : 'basic';
        this.currentListPage = this.listCurrentPage;
    }

    public canDeleteTemplate(template: any = this.workingTemplate) {
        const templateId = this.templateKey(template);
        if (!templateId) return false;
        return this.templateRows.some((row) => this.templateKey(row.template) === templateId);
    }

    public async deleteTemplateFromRow(row: any, event?: any) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (!row || !row.template) return;
        await this.deleteTemplate(row.template);
    }

    public async deleteTemplate(template: any) {
        if (!template) return;
        const templateId = this.templateKey(template);
        const templateName = template.name || '선택한 순찰 기준';

        if (!templateId || !this.canDeleteTemplate(template)) {
            this.lastActionMessage = '삭제할 순찰 기준을 확인할 수 없습니다.';
            await this.service.render();
            return;
        }

        const confirmed = await this.service.modal.show({
            title: '순찰 기준 삭제',
            message: `${templateName}을 삭제하시겠습니까? 이 작업은 되돌릴 수 없습니다.`,
            action: '삭제',
            actionBtn: 'error',
            status: 'error'
        });
        if (!confirmed) return;

        try {
            const response: any = await wiz.call('load', {
                action: 'delete',
                id: templateId
            }, { timeout: 15000 });
            const { code, data } = response || {};
            const payload = data || response || {};
            const deleted = Number(code) === 200 || Number(response && response.status) === 200 || payload.deleted === true;
            if (deleted) {
                this.removeLocalTemplate(templateId);
                this.screenMode = 'list';
                this.validationMessage = '';
                this.validationAttemptedStepId = '';
                this.lastActionMessage = `${templateName} 순찰 기준을 삭제했습니다.`;
            } else {
                this.lastActionMessage = payload.message || '순찰 기준 삭제에 실패했습니다.';
            }
        } catch (error) {
            this.lastActionMessage = '순찰 기준 삭제 중 오류가 발생했습니다.';
        }
        await this.service.render();
    }

    public async saveTemplateToDatabase(template: any, markSaved: boolean = false) {
        if (!template) return null;
        try {
            const response: any = await wiz.call('save', {
                template: JSON.stringify(template),
                markSaved: markSaved ? 'true' : 'false'
            }, { timeout: 15000 });
            const { code, data } = response || {};
            if (code === 200 && data && data.template) {
                return this.upsertLocalTemplate(data.template);
            }
            this.lastActionMessage = (data && data.message) || '순찰 기준 반영에 실패했습니다.';
        } catch (error) {
            this.lastActionMessage = '순찰 기준 반영 중 오류가 발생했습니다.';
        }
        return null;
    }

    public createDraftTemplate() {
        const village = this.activeVillage && !this.isPlaceholderVillageCode(this.activeVillage.code) ? this.activeVillage : null;
        return {
            id: `draft-${Date.now()}`,
            code: '',
            villageCode: village ? village.code : '',
            villageName: village ? village.name : '',
            name: '',
            purpose: '',
            drone: '',
            cycle: '',
            department: '',
            owner: '',
            summary: '',
            sourceType: 'custom',
            sourceLabel: '등록 기준',
            scenarioType: 'custom',
            scenarioLabel: '등록 기준',
            version: '작성 중',
            deployStatus: 'DRAFT',
            launchName: '',
            launchCoord: '',
            launchNote: '',
            pointCode: '',
            pointName: '',
            pointCoord: '',
            pointAltitude: '',
            pointHeading: '',
            pointGimbal: '',
            pointZoom: '',
            captureTime: '',
            captureAltitudeRange: '',
            captureWeather: '',
            captureNaming: '',
            referencePoint: '',
            referenceName: '',
            referenceQuality: '',
            launchPoints: [],
            points: [],
            captureRules: [],
            referencePhotos: [],
            maintenanceAlerts: []
        };
    }

    public syncDraftVillageName(render: boolean = true) {
        if (!this.draftTemplate) return;
        if (this.isPlaceholderVillageCode(this.draftTemplate.villageCode)) {
            this.draftTemplate.villageCode = '';
            this.draftTemplate.villageName = '';
            if (render) this.service.render();
            return;
        }
        const village = this.villages.find((item) => item.code === this.draftTemplate.villageCode);
        if (village) {
            this.draftTemplate.villageName = village.name;
            this.selectedVillageCode = village.code;
        }
        if (render) this.service.render();
    }

    public async filterList() {
        this.currentListPage = 1;
        this.listViewMode = 'overview';
        await this.service.render();
    }

    public async resetListFilters() {
        this.listKeyword = '';
        this.listSourceFilter = 'all';
        this.listStatusFilter = 'all';
        this.listDeployFilter = 'all';
        this.listPageSize = 8;
        this.currentListPage = 1;
        this.listViewMode = 'overview';
        await this.service.render();
    }

    public async applySummaryFilter(cardId: string) {
        this.listStatusFilter = 'all';
        this.listDeployFilter = 'all';
        this.listSourceFilter = 'all';
        if (cardId === 'ready') this.listStatusFilter = 'ready';
        if (cardId === 'needs') this.listStatusFilter = 'needs';
        if (cardId === 'deployed') this.listDeployFilter = 'deployed';
        this.currentListPage = 1;
        this.listViewMode = 'overview';
        await this.service.render();
    }

    public async setDetailTab(tabId: string) {
        this.detailTabId = tabId || 'summary';
        await this.service.render();
    }

    public async setListPage(page: number) {
        this.currentListPage = Math.min(Math.max(1, Number(page) || 1), this.listTotalPages);
        await this.service.render();
    }

    public async showCriteriaOverview() {
        this.screenMode = 'list';
        this.listViewMode = 'overview';
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.lastActionMessage = '';
        await this.service.render();
    }

    public async backToList() {
        this.screenMode = 'list';
        this.listViewMode = 'overview';
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        if (this.wizardMode === 'create') {
            this.wizardMode = this.activeTemplate ? 'view' : 'idle';
            this.draftTemplate = null;
            this.selectedTemplateId = this.activeTemplate ? this.selectedTemplateId : '';
            this.confirmedWizardStepIds = this.activeTemplate ? this.completedStepIdsForTemplate(this.activeTemplate) : [];
        }
        this.lastActionMessage = '';
        await this.service.render();
    }

    public async editTemplateFromRow(row: any, stepId: string = 'basic') {
        if (!row || !row.template) return;
        this.selectedVillageCode = row.villageCode || (row.village && row.village.code) || '';
        this.selectedTemplateId = this.templateKey(row.template);
        this.wizardMode = 'edit';
        this.screenMode = 'form';
        this.draftTemplate = this.cloneTemplate(row.template);
        this.prepareDraftInputs();
        this.confirmedWizardStepIds = this.completedStepIdsForTemplate(row.template);
        this.activeStepId = stepId || this.firstIncompleteStepId();
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.lastActionMessage = `${row.template.name || '선택 기준'} 수정 중`;
        await this.service.render();
    }

    public async selectTemplateFromRow(row: any) {
        if (!row || !row.template) return;
        this.selectedVillageCode = row.villageCode || (row.village && row.village.code) || '';
        this.selectedTemplateId = this.templateKey(row.template);
        this.wizardMode = 'view';
        this.screenMode = 'list';
        this.listViewMode = 'detail';
        this.detailTabId = 'summary';
        this.activeStepId = this.firstIncompleteStepId();
        this.draftTemplate = null;
        this.confirmedWizardStepIds = this.completedStepIdsForTemplate(row.template);
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.lastActionMessage = `${row.template.name || '선택 기준'} 상세를 열었습니다.`;
        await this.service.render();
    }

    public async selectVillage(code: string) {
        this.selectedVillageCode = code;
        const village = this.villages.find((item) => item.code === code) || null;
        const firstTemplate = village && village.templates && village.templates.length ? village.templates[0] : null;
        this.selectedTemplateId = firstTemplate ? this.templateKey(firstTemplate) : '';
        this.wizardMode = firstTemplate ? 'view' : 'idle';
        this.activeStepId = firstTemplate ? this.firstIncompleteStepId() : 'basic';
        this.draftTemplate = null;
        this.confirmedWizardStepIds = firstTemplate ? this.completedStepIdsForTemplate(firstTemplate) : [];
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.lastActionMessage = village ? `${village.name} 마을을 선택했습니다.` : '';
        await this.service.render();
    }

    public async selectTemplate(template: any) {
        this.selectedTemplateId = this.templateKey(template);
        this.wizardMode = 'view';
        this.screenMode = 'list';
        this.listViewMode = 'detail';
        this.detailTabId = 'summary';
        this.activeStepId = this.firstIncompleteStepId();
        this.draftTemplate = null;
        this.confirmedWizardStepIds = this.completedStepIdsForTemplate(template);
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.lastActionMessage = `${template.name || '선택 기준'} 선택됨`;
        await this.service.render();
    }

    public async createTemplate() {
        this.wizardMode = 'create';
        this.screenMode = 'form';
        this.listViewMode = 'overview';
        this.activeStepId = 'basic';
        this.draftTemplate = this.createDraftTemplate();
        this.selectedTemplateId = '';
        this.confirmedWizardStepIds = [];
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.lastActionMessage = '새 기준 작성 중';
        await this.service.render();
    }

    public async editTemplate(stepId: string = 'basic') {
        if (!this.activeTemplate) {
            await this.createTemplate();
            return;
        }
        this.wizardMode = 'edit';
        this.screenMode = 'form';
        this.listViewMode = 'detail';
        this.activeStepId = stepId;
        this.draftTemplate = this.cloneTemplate(this.activeTemplate);
        this.prepareDraftInputs();
        this.confirmedWizardStepIds = this.completedStepIdsForTemplate(this.activeTemplate);
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.lastActionMessage = `${this.stepLabel(stepId)} 수정 중`;
        await this.service.render();
    }

    public async handleChecklistClick(item: any) {
        if (!item) return;
        if (item.id === 'village' && !this.selectedVillageCode && this.villages.length) {
            await this.selectVillage(this.villages[0].code);
            return;
        }
        if (item.id === 'deploy') {
            await this.deployTemplate();
            return;
        }
        await this.openStep(item.stepId || 'basic');
    }

    public async openMaintenanceIssue(issue: any) {
        if (!issue) return;
        await this.openStep(issue.stepId || 'points');
    }

    public async openStep(stepId: string) {
        if (!this.workingTemplate) {
            await this.createTemplate();
            return;
        }
        if (!this.isEditing) {
            await this.editTemplate(stepId);
            return;
        }
        this.activeStepId = stepId;
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.lastActionMessage = `${this.stepLabel(stepId)} 단계로 이동했습니다.`;
        await this.service.render();
    }

    public async goPreviousStep() {
        const previous = this.previousStepId;
        if (!previous) return;
        this.activeStepId = previous;
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.lastActionMessage = `${this.stepLabel(previous)} 단계로 돌아왔습니다.`;
        await this.service.render();
    }

    public async goNextStep() {
        if (this.activeStepId === 'basic') return await this.saveBasicInfo();
        if (this.activeStepId === 'launch') return await this.saveLaunchPoint();
        if (this.activeStepId === 'points') return await this.saveObservationPoint();
        if (this.activeStepId === 'capture') return await this.saveCaptureRules();
        if (this.activeStepId === 'reference') return await this.approveReferences();
        return await this.deployTemplate();
    }

    public async saveDraftTemporarily() {
        if (!this.workingTemplate) {
            await this.createTemplate();
            return;
        }
        if (!this.isEditing) {
            await this.editTemplate(this.activeStepId);
            return;
        }
        this.syncDraftVillageName(false);
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.draftTemplate.version = '작성 중';
        this.draftTemplate.lastModified = '방금 전';
        const saved = this.persistDraftTemplate(false);
        if (saved) {
            const persisted = await this.saveTemplateToDatabase(saved, false);
            if (!persisted) {
                await this.service.render();
                return;
            }
            this.draftTemplate = this.cloneTemplate(persisted);
            this.prepareDraftInputs();
        }
        this.lastActionMessage = '작성 내용이 반영되었습니다.';
        await this.service.render();
    }

    public stepLabel(stepId: string) {
        const step = this.wizardSteps.find((item) => item.id === stepId);
        return step ? step.label : '단계';
    }

    public prepareDraftInputs() {
        if (!this.draftTemplate) return;
        const launch = this.draftTemplate.launchPoints && this.draftTemplate.launchPoints.length ? this.draftTemplate.launchPoints[0] : null;
        const point = this.draftTemplate.points && this.draftTemplate.points.length ? this.draftTemplate.points[0] : null;
        const photo = this.draftTemplate.referencePhotos && this.draftTemplate.referencePhotos.length ? this.draftTemplate.referencePhotos[0] : null;
        if (launch) {
            this.draftTemplate.launchName = launch.name || '';
            this.draftTemplate.launchCoord = launch.coord || launch.coordinate || '';
            this.draftTemplate.launchNote = launch.note || launch.safetyNote || '';
        }
        if (point) {
            this.draftTemplate.pointCode = point.code || '';
            this.draftTemplate.pointName = point.name || '';
            this.draftTemplate.pointCoord = point.coord || point.coordinate || '';
            this.draftTemplate.pointAltitude = point.altitude || '';
            this.draftTemplate.pointHeading = point.heading || point.direction || '';
            this.draftTemplate.pointGimbal = point.gimbal || point.gimbalAngle || '';
            this.draftTemplate.pointZoom = point.zoom || point.zoomRatio || '';
        }
        if (this.draftTemplate.captureRules && this.draftTemplate.captureRules.length) {
            this.draftTemplate.captureTime = this.findRuleValue('촬영 시간대');
            this.draftTemplate.captureAltitudeRange = this.findRuleValue('고도 허용 범위');
            this.draftTemplate.captureWeather = this.findRuleValue('비행 가능 날씨');
            this.draftTemplate.captureNaming = this.findRuleValue('사진 정리 규칙');
        }
        if (photo) {
            this.draftTemplate.referencePoint = photo.point || '';
            this.draftTemplate.referenceName = photo.name || '';
            this.draftTemplate.referenceQuality = photo.quality || '';
        }
    }

    public findRuleValue(label: string) {
        const rule = (this.draftTemplate.captureRules || []).find((item) => item.label === label);
        return rule ? rule.value : '';
    }

    public validateBasic() {
        this.syncDraftVillageName(false);
        if (!this.draftTemplate) return '새 순찰 기준 작성을 먼저 시작하세요.';
        return this.stepMissingMessage('basic');
    }

    public async saveBasicInfo() {
        this.validationAttemptedStepId = 'basic';
        const error = this.validateBasic();
        if (error) {
            this.validationMessage = error;
            this.lastActionMessage = '기본 정보에서 확인이 필요한 항목을 표시했습니다.';
        } else {
            this.draftTemplate.owner = this.draftTemplate.department;
            this.draftTemplate.summary = `${this.draftTemplate.villageName || this.selectedVillageLabel()} 순찰 기준`;
            this.validationMessage = '';
            this.validationAttemptedStepId = '';
            this.confirmWizardStep('basic');
            this.activeStepId = 'launch';
            this.lastActionMessage = '마을 선택을 반영하고 이륙 지점 단계로 이동했습니다.';
        }
        await this.service.render();
    }

    public async saveLaunchPoint() {
        if (!this.draftTemplate) return await this.openStep('basic');
        this.validationAttemptedStepId = 'launch';
        const error = this.stepMissingMessage('launch');
        if (error) {
            this.validationMessage = error;
            this.lastActionMessage = '이륙 지점에서 확인이 필요한 항목을 표시했습니다.';
        } else {
            this.draftTemplate.launchPoints = [{
                name: this.draftTemplate.launchName,
                coord: this.draftTemplate.launchCoord,
                note: this.draftTemplate.launchNote,
                status: 'ACTIVE'
            }];
            this.validationMessage = '';
            this.validationAttemptedStepId = '';
            this.confirmWizardStep('launch');
            this.activeStepId = 'points';
            this.lastActionMessage = '이륙 지점을 반영하고 관측 포인트 등록 단계로 이동했습니다.';
        }
        await this.service.render();
    }

    public async saveObservationPoint() {
        if (!this.draftTemplate) return await this.openStep('basic');
        this.validationAttemptedStepId = 'points';
        const error = this.stepMissingMessage('points');
        if (error) {
            this.validationMessage = error;
            this.lastActionMessage = '관측 포인트에서 확인이 필요한 항목을 표시했습니다.';
        } else {
            const currentPoint = this.draftTemplate.points && this.draftTemplate.points.length ? this.draftTemplate.points[0] : {};
            const point = {
                code: this.draftTemplate.pointCode,
                name: this.draftTemplate.pointName,
                coord: this.draftTemplate.pointCoord,
                altitude: currentPoint.altitude || this.draftTemplate.pointAltitude || '',
                heading: currentPoint.heading || currentPoint.direction || this.draftTemplate.pointHeading || '',
                gimbal: currentPoint.gimbal || currentPoint.gimbalAngle || this.draftTemplate.pointGimbal || '',
                zoom: currentPoint.zoom || currentPoint.zoomRatio || this.draftTemplate.pointZoom || '',
                status: 'ACTIVE'
            };
            this.draftTemplate.points = [point];
            this.validationMessage = '';
            this.validationAttemptedStepId = '';
            this.confirmWizardStep('points');
            this.activeStepId = 'capture';
            this.lastActionMessage = '관측 포인트를 반영하고 촬영 기준값 입력 단계로 이동했습니다.';
        }
        await this.service.render();
    }

    public async saveCaptureRules() {
        if (!this.draftTemplate) return await this.openStep('basic');
        this.validationAttemptedStepId = 'capture';
        const error = this.stepMissingMessage('capture');
        if (error) {
            this.validationMessage = error;
            this.lastActionMessage = '촬영 기준값에서 확인이 필요한 항목을 표시했습니다.';
        } else {
            const point = this.draftTemplate.points && this.draftTemplate.points.length ? this.draftTemplate.points[0] : {
                code: this.draftTemplate.pointCode,
                name: this.draftTemplate.pointName,
                coord: this.draftTemplate.pointCoord,
                status: 'ACTIVE'
            };
            this.draftTemplate.points = [{
                ...point,
                altitude: this.draftTemplate.pointAltitude,
                heading: this.draftTemplate.pointHeading,
                gimbal: this.draftTemplate.pointGimbal,
                zoom: this.draftTemplate.pointZoom,
                status: point.status || 'ACTIVE'
            }];
            this.draftTemplate.captureRules = [
                { label: '촬영 시간대', value: this.draftTemplate.captureTime, note: '반복 순찰에 사용할 촬영 시간' },
                { label: '고도 허용 범위', value: this.draftTemplate.captureAltitudeRange, note: '관측 포인트별 촬영 높이 범위' },
                { label: '비행 가능 날씨', value: this.draftTemplate.captureWeather, note: '풍속, 강수, 시정 확인 기준' },
                { label: '사진 정리 규칙', value: this.draftTemplate.captureNaming, note: '마을, 관측 포인트, 회차 식별 방식' }
            ];
            this.validationMessage = '';
            this.validationAttemptedStepId = '';
            this.confirmWizardStep('capture');
            this.activeStepId = 'reference';
            this.lastActionMessage = '촬영 기준값을 반영하고 기준 사진 승인 단계로 이동했습니다.';
        }
        await this.service.render();
    }

    public async addReferencePhoto() {
        if (!this.draftTemplate) return await this.openStep('basic');
        this.validationAttemptedStepId = 'reference';
        const error = this.stepMissingMessage('reference');
        if (error) {
            this.validationMessage = error;
            this.lastActionMessage = '기준 사진에서 확인이 필요한 항목을 표시했습니다.';
            await this.service.render();
            return;
        }
        this.draftTemplate.referencePhotos = [{
            point: this.draftTemplate.referencePoint,
            name: this.draftTemplate.referenceName,
            status: 'PENDING',
            quality: this.draftTemplate.referenceQuality || '품질 확인 대기',
            updatedAt: '작성 중'
        }];
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.lastActionMessage = '기준 사진을 등록했습니다. 승인 후 다음 단계로 이동할 수 있습니다.';
        await this.service.render();
    }

    public async approveReferences() {
        if (!this.draftTemplate) return await this.openStep('basic');
        this.validationAttemptedStepId = 'reference';
        const error = this.stepMissingMessage('reference');
        if (error) {
            this.validationMessage = error;
            this.lastActionMessage = '기준 사진에서 확인이 필요한 항목을 표시했습니다.';
            await this.service.render();
            return;
        }
        if (!this.draftTemplate.referencePhotos || !this.draftTemplate.referencePhotos.length) {
            this.draftTemplate.referencePhotos = [{
                point: this.draftTemplate.referencePoint,
                name: this.draftTemplate.referenceName,
                status: 'PENDING',
                quality: this.draftTemplate.referenceQuality || '품질 확인 대기',
                updatedAt: '작성 중'
            }];
        }
        this.draftTemplate.referencePhotos = this.draftTemplate.referencePhotos.map((photo) => ({
            point: photo.point,
            name: photo.name,
            status: 'APPROVED',
            quality: photo.quality && photo.quality !== '품질 확인 대기' ? photo.quality : '승인 기준 충족',
            updatedAt: '방금 전'
        }));
        this.draftTemplate.approvalStatus = 'APPROVED';
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.confirmWizardStep('reference');
        this.activeStepId = 'deploy';
        this.lastActionMessage = '기준 사진을 승인하고 반영 및 배포 단계로 이동했습니다.';
        await this.service.render();
    }

    public persistDraftTemplate(markSaved: boolean = true) {
        if (!this.draftTemplate) return null;
        const template = this.cloneTemplate(this.draftTemplate);
        template.id = this.templateKey(template) || `template-${Date.now()}`;
        template.code = template.code || `TPL-${new Date().getFullYear()}-${(this.templateRows.length + 1).toString().padStart(2, '0')}`;
        template.owner = template.department;
        template.sourceType = 'custom';
        template.sourceLabel = '등록 기준';
        template.scenarioType = 'custom';
        template.scenarioLabel = '등록 기준';
        template.version = markSaved ? 'v1 작성본' : (template.version || '작성 중');
        template.lastModified = '방금 전';
        if (!template.deployStatus) template.deployStatus = markSaved ? 'UNDEPLOYED' : 'DRAFT';
        if (markSaved && template.deployStatus === 'DRAFT') template.deployStatus = 'UNDEPLOYED';
        return this.upsertLocalTemplate(template);
    }

    public async saveTemplate() {
        if (!this.workingTemplate) {
            await this.createTemplate();
            return;
        }
        if (this.isEditing) {
            const basicError = this.validateBasic();
            if (basicError) {
                this.activeStepId = 'basic';
                this.validationAttemptedStepId = 'basic';
                this.validationMessage = basicError;
                this.lastActionMessage = '반영 전에 기본 정보 확인이 필요합니다.';
                await this.service.render();
                return;
            }
            const saved = this.persistDraftTemplate(true);
            const persisted = await this.saveTemplateToDatabase(saved, true);
            if (!persisted) {
                await this.service.render();
                return;
            }
            this.wizardMode = 'view';
            this.draftTemplate = null;
            this.activeStepId = this.firstIncompleteStepId();
            this.validationMessage = '';
            this.validationAttemptedStepId = '';
            this.lastActionMessage = `${persisted.name || '순찰 기준'} 기준 정보가 반영되었습니다.`;
        } else {
            const persisted = await this.saveTemplateToDatabase(this.activeTemplate, true);
            if (!persisted) {
                await this.service.render();
                return;
            }
            this.lastActionMessage = `${persisted.name || '선택 기준'} 기준 정보가 반영되었습니다.`;
            this.activeStepId = this.firstIncompleteStepId();
        }
        await this.service.render();
    }

    public async deployTemplate() {
        if (!this.workingTemplate) {
            await this.createTemplate();
            return;
        }
        let template = this.workingTemplate;
        if (this.isEditing) {
            const basicError = this.validateBasic();
            if (basicError) {
                this.activeStepId = 'basic';
                this.validationAttemptedStepId = 'basic';
                this.validationMessage = basicError;
                this.lastActionMessage = '배포 전에 기본 정보 확인이 필요합니다.';
                await this.service.render();
                return;
            }
            template = this.persistDraftTemplate(true);
            template = await this.saveTemplateToDatabase(template, true);
            if (!template) {
                await this.service.render();
                return;
            }
            this.wizardMode = 'view';
            this.draftTemplate = null;
        }
        const missing = this.wizardSteps.find((step) => step.id !== 'deploy' && step.state !== 'done');
        if (missing) {
            this.activeStepId = missing.id;
            this.lastActionMessage = `${workflowStatusLabel('setup')}: ${missing.label}`;
            await this.editTemplate(missing.id);
            return;
        }
        template.deployStatus = 'DEPLOYED';
        template.deployTarget = '순찰 실행에 반영됨';
        template.lastModified = '방금 전';
        template = this.upsertLocalTemplate(template);
        const persisted = await this.saveTemplateToDatabase(template, true);
        if (!persisted) {
            await this.service.render();
            return;
        }
        this.activeStepId = 'deploy';
        this.validationMessage = '';
        this.validationAttemptedStepId = '';
        this.confirmWizardStep('deploy');
        this.lastActionMessage = `${persisted.name || '순찰 기준'} ${workflowStatusLabel('assigned')}`;
        await this.service.render();
    }
}

export default PageVillagesComponent;